export const SCREENS = {
  PRIVATE: {
    BROKER: {
      INDEX: { path: "/broker", breadcrumb: [] },
      DASHBOARD: { path: "/broker/dashboard", breadcrumb: [] },
      CONTRACTS: {
        LIST: { path: "/broker/contracts", breadcrumb: [] },
        CREATE: { path: "/broker/contracts/create", breadcrumb: [] },
        DETAIL: { path: "/broker/contracts/detail", breadcrumb: [] },
        DELETE: { path: "/broker/contracts/delete", breadcrumb: [] },
      },
      CLIENTS: {
        LIST: { path: "/broker/clients", breadcrumb: [] },
        CREATE: { path: "/broker/clients/create", breadcrumb: [] },
        DETAIL: { path: "/broker/clients/detail", breadcrumb: [] },
      },
      QUALIFICATIONS: {
        LIST: { path: "/broker/qualifications", breadcrumb: [] },
        CREATE: { path: "/broker/qualifications/create", breadcrumb: [] },
        SHOW: { path: "/broker/qualifications/show", breadcrumb: [] },
      },
      NOTES: {
        LIST: { path: "/broker/notes", breadcrumb: [] },
        CREATE: { path: "/broker/notes/create", breadcrumb: [] },
        DELETE: { path: "/broker/notes/delete", breadcrumb: [] },
      },
      ORGANIZATIONS: {
        LIST: { path: "/broker/organizations", breadcrumb: [] },
        CREATE: { path: "/broker/organizations/create", breadcrumb: [] },
        DETAIL: { path: "/broker/organizations/detail", breadcrumb: [] },
        DELETE: { path: "/broker/organizations/delete", breadcrumb: [] },
      },
      PROJECTS: {
        LIST: { path: "/broker/projects", breadcrumb: [] },
        CREATE: {
          NORMAL: { path: "/broker/projects/create/normal", breadcrumb: [] },
          FAST: { path: "/broker/projects/create/fast", breadcrumb: [] },
        },
        FROM_SOURCE: { path: "/broker/projects/source", breadcrumb: [] },
        DETAIL: {
          path: "/broker/projects/detail",
          breadcrumb: [
            { label: "PRIVATE.BROKER.DASHBOARD", to: "" },
            { label: "PRIVATE.BROKER.PROJECT.CREATE", to: "" },
            { label: "PRIVATE.BROKER.PROJECT.DETAIL", to: "" },
          ],
        },
        DELETE: { path: "/broker/projects/delete", breadcrumb: [] },
        TRACERS: {
          IDENTIFY: {
            path: "/broker/projects/tracers/identify",
            breadcrumb: [],
          },
        },
      },
      USERS: {
        LIST: { path: "/broker/users", breadcrumb: [] },
        CREATE: { path: "/broker/users/create", breadcrumb: [] },
        DETAIL: { path: "/broker/users/detail", breadcrumb: [] },
        DELETE: { path: "/broker/users/delete", breadcrumb: [] },
      },
      REMINDERS: {
        LIST: { path: "/broker/reminders", breadcrumb: [] },
        CREATE: { path: "/broker/reminders/create", breadcrumb: [] },
      },
      SUBSCRIPTIONS: {
        DETAIL: { path: "/broker/subscriptions/detail", breadcrumb: [] },
        SEND_LINK: { path: "/broker/subscriptions/sendLink", breadcrumb: [] },
      },
      COLLABORATORS: {
        LIST: { path: "/broker/collaborators", breadcrumb: [] },
        CREATE: { path: "/broker/collaborators/create", breadcrumb: [] },
        DETAIL: { path: "/broker/collaborators/detail", breadcrumb: [] },
        DELETE: { path: "/broker/collaborators/delete", breadcrumb: [] },
      },
      COMMISSION_STATEMENTS: {
        LIST: { path: "/broker/commissions-statements", breadcrumb: [] },
      },
      NOTIFICATIONS: {
        LIST: { path: "/broker/notifications", breadcrumb: [] },
      },
      TASKS: {
        LIST: { path: "/broker/tasks", breadcrumb: [] },
        CREATE: { path: "/broker/tasks/create", breadcrumb: [] },
        DELETE: { path: "/broker/tasks/delete", breadcrumb: [] },
      },
    },
    GUEST: {
      PROJECTS: {
        DETAIL: {
          path: "/guest/projects/detail",
          breadcrumb: [],
        },
      },
    },
    ADMIN: {
      INDEX: { path: "/admin", breadcrumb: [] },
      DASHBOARD: { path: "/admin/dashboard", breadcrumb: [] },
      PROCESSES: {
        LIST: { path: "/admin/processes", breadcrumb: [] },
        CREATE: { path: "/admin/processes/create", breadcrumb: [] },
        DETAIL: { path: "/admin/processes/detail", breadcrumb: [] },
        DELETE: { path: "/admin/processes/delete", breadcrumb: [] },
        FLOW_LEGACY: { path: "/admin/processes/flow", breadcrumb: [] },
      },
      CANVASES: {
        path: "/admin/canvases",
        breadcrumb: [],
        LIST: { path: "/admin/canvases", breadcrumb: [] },
      },
      INTEGRATION_PARAMETERS: {
        path: "/admin/integration-parameters",
        breadcrumb: [],
        LIST: { path: "/admin/integration-parameters", breadcrumb: [] },
      },
      CONNECTOR_LOGS: {
        path: "/admin/connector-logs",
        breadcrumb: [],
        LIST: { path: "/admin/connector-logs", breadcrumb: [] },
      },
      FLOWS: {
        LIST: { path: "/admin/flows", breadcrumb: [] },
        CREATE: { path: "/admin/flows/create", breadcrumb: [] },
        DETAIL: { path: "/admin/flows/detail", breadcrumb: [] },
        DELETE: { path: "/admin/flows/delete", breadcrumb: [] },
      },
      TRACERS: {
        LIST: { path: "/admin/tracers", breadcrumb: [] },
        CREATE: { path: "/admin/tracers/create", breadcrumb: [] },
        DETAIL: { path: "/admin/tracers/detail", breadcrumb: [] },
        DELETE: { path: "/admin/tracers/delete", breadcrumb: [] },
      },
      SOURCES: {
        LIST: { path: "/admin/sources", breadcrumb: [] },
      },
      LEAD_TYPOLOGIES: {
        LIST: { path: "/admin/lead-typologies", breadcrumb: [] },
      },
      USERS: {
        LIST: { path: "/admin/users", breadcrumb: [] },
        CREATE: { path: "/admin/users/create", breadcrumb: [] },
        DETAIL: { path: "/admin/users/detail", breadcrumb: [] },
        DELETE: { path: "/admin/users/delete", breadcrumb: [] },
        DEACTIVATE: { path: "/admin/users/deactivate", breadcrumb: [] },
      },
      BROKERS: {
        LIST: { path: "/admin/brokers", breadcrumb: [] },
        CREATE: { path: "/admin/brokers/create", breadcrumb: [] },
        DETAIL: { path: "/admin/brokers/detail", breadcrumb: [] },
        DELETE: { path: "/admin/brokers/delete", breadcrumb: [] },
      },
      DISPATCHERS: {
        LIST: { path: "/admin/dispatchers", breadcrumb: [] },
      },
      ORGANIZATIONS: {
        LIST: { path: "/admin/organizations", breadcrumb: [] },
        CREATE: { path: "/admin/organizations/create", breadcrumb: [] },
        DETAIL: { path: "/admin/organizations/detail", breadcrumb: [] },
        DELETE: { path: "/admin/organizations/delete", breadcrumb: [] },
      },
      COMPANIES: {
        LIST: { path: "/broker/companies", breadcrumb: [] },
        CREATE: { path: "/broker/companies/create", breadcrumb: [] },
        DETAIL: { path: "/broker/companies/detail", breadcrumb: [] },
        DELETE: { path: "/broker/companies/delete", breadcrumb: [] },
      },
      INSURANCE_PLANS: {
        LIST: { path: "/admin/insurance-plans", breadcrumb: [] },
        CREATE: { path: "/admin/insurance-plans/create", breadcrumb: [] },
        DETAIL: { path: "/admin/insurance-plans/detail", breadcrumb: [] },
        DELETE: { path: "/admin/insurance-plans/delete", breadcrumb: [] },
        EDIT: { path: "/admin/insurance-plans/edit", breadcrumb: [] },
        CONFIGURE: { path: "/admin/insurance-plans/configure", breadcrumb: [] },
        IMPORT_PARAMS: {
          path: "/admin/insurance-plans/import-params",
          breadcrumb: [],
        },
        IMPORT_DOCS: {
          path: "/admin/insurance-plans/import-docs",
          breadcrumb: [],
        },
      },
      OFFERS: {
        LIST: { path: "/admin/offers", breadcrumb: [] },
        DELETE: { path: "/admin/offers/delete", breadcrumb: [] },
      },
      COVERAGES: {
        LIST: { path: "/admin/coverages", breadcrumb: [] },
        CREATE: { path: "/admin/coverages/create", breadcrumb: [] },
        DETAIL: { path: "/admin/coverages/detail", breadcrumb: [] },
        DELETE: { path: "/admin/coverages/delete", breadcrumb: [] },
      },
      COVERAGE_BENEFITS: {
        LIST: { path: "/admin/coverage-benefits", breadcrumb: [] },
        CREATE: { path: "/admin/coverage-benefits/create", breadcrumb: [] },
        DETAIL: { path: "/admin/coverage-benefits/detail", breadcrumb: [] },
        DELETE: { path: "/admin/coverage-benefits/delete", breadcrumb: [] },
      },
      QUALIFIERS: {
        LIST: { path: "/admin/qualifiers", breadcrumb: [] },
        CREATE: { path: "/admin/qualifiers/create", breadcrumb: [] },
        DETAIL: { path: "/admin/qualifiers/detail", breadcrumb: [] },
        DELETE: { path: "/admin/qualifiers/delete", breadcrumb: [] },
      },
      QUALIFICATIONS: {
        LIST: { path: "/admin/qualifications", breadcrumb: [] },
        CREATE: { path: "/admin/qualifications/create", breadcrumb: [] },
        SHOW: { path: "/admin/qualifications/show", breadcrumb: [] },
      },
      WEBHOOKS: {
        LIST: { path: "/admin/webhooks", breadcrumb: [] },
      },
      COVERAGE_CATEGORIES: {
        LIST: { path: "/admin/coverage-categories", breadcrumb: [] },
        CREATE: { path: "/admin/coverage-categories/create", breadcrumb: [] },
        DETAIL: { path: "/admin/coverage-categories/detail", breadcrumb: [] },
        DELETE: { path: "/admin/coverage-categories/delete", breadcrumb: [] },
        WEIGHT: { path: "/admin/coverage-categories/weight", breadcrumb: [] },
      },
      PRODUCT_RANGES: {
        LIST: { path: "/admin/product-ranges", breadcrumb: [] },
        SELLER_CODES: {
          path: "/admin/product-ranges/seller-codes",
          breadcrumb: [],
        },
        CREATE: { path: "/admin/product-ranges/create", breadcrumb: [] },
        DETAIL: { path: "/admin/product-ranges/detail", breadcrumb: [] },
        DELETE: { path: "/admin/product-ranges/delete", breadcrumb: [] },
      },
      UI: {
        LIST: { path: "/admin/ui", breadcrumb: [] },
        LMF: { path: "/admin/ui/lmf", breadcrumb: [] },
      },
      WORKFLOWS: {
        LIST: { path: "/admin/workflows", breadcrumb: [] },
        CREATE: { path: "/admin/workflows/create", breadcrumb: [] },
        DETAIL: { path: "/admin/workflows/detail", breadcrumb: [] },
        DELETE: { path: "/admin/workflows/delete", breadcrumb: [] },
      },
      DISCOUNT_CODES: {
        LIST: { path: "/admin/discount-codes", breadcrumb: [] },
        CREATE: { path: "/admin/discount-codes/create", breadcrumb: [] },
        DETAIL: { path: "/admin/discount-codes/detail", breadcrumb: [] },
        DELETE: { path: "/admin/discount-codes/delete", breadcrumb: [] },
      },
      PRICERS: {
        LIST: { path: "/admin/prices", breadcrumb: [] },
        CREATE: { path: "/admin/prices/create", breadcrumb: [] },
        DETAIL: { path: "/admin/prices/detail", breadcrumb: [] },
        DELETE: { path: "/admin/prices/delete", breadcrumb: [] },
        GEO_ZONES: { path: "/admin/prices/geo-zones", breadcrumb: [] },
        REFERENTIALS: { path: "/admin/prices/referentials", breadcrumb: [] },
      },
      COMMISSION_STATEMENTS: {
        LIST: { path: "/admin/commissions-statements", breadcrumb: [] },
        CREATE: {
          path: "/admin/commissions-statements/create",
          breadcrumb: [],
        },
        DELETE: {
          path: "/admin/commissions-statements/delete",
          breadcrumb: [],
        },
      },
      COMMISSIONS: {
        LIST: { path: "/admin/commissions", breadcrumb: [] },
        CREATE: { path: "/admin/commissions/create", breadcrumb: [] },
        DETAIL: { path: "/admin/commissions/detail", breadcrumb: [] },
        DELETE: { path: "/admin/commissions/delete", breadcrumb: [] },
      },
      DYNAMIC_DOCUMENTS: {
        LIST: { path: "/admin/documents", breadcrumb: [] },
        CREATE: { path: "/admin/documents/create", breadcrumb: [] },
        EDIT: { path: "/admin/documents/edit", breadcrumb: [] },
      },
      SCREEN_STUDIOS: {
        LIST: { path: "/admin/screen-studios", breadcrumb: [] },
        CREATE: { path: "/admin/screen-studios/create", breadcrumb: [] },
        DETAIL: { path: "/admin/screen-studios/detail", breadcrumb: [] },
        DELETE: { path: "/admin/screen-studios/delete", breadcrumb: [] },
      },
      BRANDS: {
        LIST: { path: "/admin/brands", breadcrumb: [] },
        CREATE: { path: "/admin/brands/create", breadcrumb: [] },
        DETAIL: { path: "/admin/brands/detail", breadcrumb: [] },
        DELETE: { path: "/admin/brands/delete", breadcrumb: [] },
      },
      STORES: {
        LIST: { path: "/admin/stores", breadcrumb: [] },
        CREATE: { path: "/admin/stores/create", breadcrumb: [] },
        DETAIL: { path: "/admin/stores/detail", breadcrumb: [] },
        DELETE: { path: "/admin/stores/delete", breadcrumb: [] },
      },
      EMAIL_TEMPLATES: {
        LIST: { path: "/admin/email-templates", breadcrumb: [] },
        CREATE: { path: "/admin/email-templates/create", breadcrumb: [] },
        DETAIL: { path: "/admin/email-templates/detail", breadcrumb: [] },
        DELETE: { path: "/admin/email-templates/delete", breadcrumb: [] },
      },
    },
    EXCHANGE: { path: "/exchange", breadcrumb: [] },
  },
  AUTH: {
    REDIRECT: { path: "/auth/redirect", breadcrumb: [] },
    LOGOUT: { path: "/auth/logout", breadcrumb: [] },
    SIGN_IN: { path: "/", breadcrumb: [] },
    SIGN_IN_TWO_FACTOR: { path: "auth/two-factor", breadcrumb: [] },
    VERIFICATION: { path: "/auth/verification", breadcrumb: [] },
    RESET_PASSWORD: { path: "/auth/password/passcode", breadcrumb: [] },
    SET_PASSWORD: { path: "/auth/set-password", breadcrumb: [] },
    FORGOT_PASSWORD: { path: "/auth/password/forgot", breadcrumb: [] },
    NOT_ACTIVE: { path: "/auth/not-active", breadcrumb: [] },
    NOT_AUTHORIZED: { path: "/auth/not-authorized", breadcrumb: [] },
    ZITADEL_CALLBACK: { path: "/auth/callback", breadcrumb: [] },
  },
  PUBLIC: {
    INDEX: { path: "/", breadcrumb: [] },
    HANDOVER: { path: "/handover", breadcrumb: [] },
    CONTACTS: {
      INDEX: { path: "/contacts", breadcrumb: [] },
    },
    NOTES: {
      CREATE: { path: "/notes/create", breadcrumb: [] },
    },
    QUOTES: {
      DETAIL: { path: "/quotes", breadcrumb: [] },
    },
    PROCESSES: {
      IFRAME: { path: "/public/process", breadcrumb: [] },
      DETAIL: { path: "/public/process", breadcrumb: [] },
      CREATE: { path: "/public/process/create", breadcrumb: [] },
      INIT: { path: "/public/process/init", breadcrumb: [] },
      UNAVAILABLE: { path: "/public/process/unavailable", breadcrumb: [] },
      INIT_PROJECT: { path: "/project/init", breadcrumb: [] },
    },
  },
};

export const CONTRACT_TYPES = {
  PRIVACY: "PRIVACY",
  DISCLOSURE: "DISCLOSURE",
  HEALTHINSURANCE: "HEALTHINSURANCE",
  SUPPLY: "SUPPLY",
  CONSENT: "CONSENT",
};

export const CONTRACT_SUBTYPES = ["DISCLOSURE_CA", "DISCLOSURE_US"];

export const CONTRACT_CONTENT_DERIVATIVE = [
  "REGISTRATION",
  "RETRIEVAL",
  "STATEMENT",
  "SHAREABLE",
];

export const CONTRACT_EXPIRATION_TYPES = ["BREACH"];

export const CONTRACT_SCOPE = ["POLICY"];

export const ORGANIZATION_TYPE = [
  "PROV",
  "DEPT",
  "TEAM",
  "GOVT",
  "INS",
  "PAY",
  "EDU",
  "RELI",
  "CRS",
  "CG",
  "BUS",
  "BROKER",
  "OTHER",
];

export const PROCESS_URL_PARAMS = {
  PROJECT_ID: "p",
  STATUS_ID: "status",
  LINK_ID: "l",
  USER_ID: "uid",
  BIRTH_DATE: "birthDate",
  TRACKON_REQID: "id",
};

export const KEYS = {
  ACCESS_TOKEN: "accessToken",
  USER: "user",
  LANGUAGE: "language",
  PROJECT_ID: "projectId",
  SUBSCRIPTION_ID: "subscriptionId",
  STATUS_ID: "statusId",
  PROCESS_RUNTIME: "processRuntime",
  GUEST_USER_ID: "guestUserId",
  LINK_ID: "linkId",
  TEMPLATE_HISTORY: "templateHistory",
  SOURCE: "source",
  PAGINATION: "pagination",
  DASHBOARD_PROCESS_FILTERS: "dashboardProcessFilters",
  DASHBOARD_FILTERS: "dashboardFilters",
  ONESIGNAL_NOTIFICATION_PROMPT: "onesignal-notification-prompt",
  AUTH_PROVIDER: "authProvider",
  PROJECTS_SCOPE_TAB: "projectsScopeTab",
  PROJECTS_HOT_MODE: "projectsHotMode",
  PROJECTS_ADVANCED_FILTERS: "projectsAdvancedFilters",
  PROJECTS_SEARCH: "projectsSearch",
  PROJECTS_SIGNAL_FEED: "projectsSignalFeed",
};

export const PROJECTS_SCOPE = {
  MINE: "MINE",
  ORGANIZATION: "ORGANIZATION",
};

export const HOT_LIST = {
  TIERS: {
    3: "hot",
    2: "warm",
    1: "mild",
  },
  HOT_TIER: 3,

  ORDER_BY: [
    { heatTier: { order: "DESC", nulls: "NULLS LAST" } },
    { heatScore: { order: "DESC", nulls: "NULLS LAST" } },
    { createdDate: "DESC" },
  ],
  REFETCH_DEBOUNCE_MS: 1500,
  PAGE_SIZE: 20,
  SIGNALS_TAKE: 14,
  SIGNAL_TYPES: {
    ARRIVAL_ORIGIN: "ARRIVAL_ORIGIN",
    ARRIVAL_FRESHNESS: "ARRIVAL_FRESHNESS",
    INBOUND_CALL: "INBOUND_CALL",
    CALL_LATER: "CALL_LATER",
    EMAIL_OPENED: "EMAIL_OPENED",
    EMAIL_CLICKED: "EMAIL_CLICKED",
    REACHED: "REACHED",
    EXIT: "EXIT",
  },
  MOVE_HIGHLIGHT_MS: 30 * 1000,
  DECAY_WINDOW_MS: 5 * 60 * 1000,
  DECAY_MIN_AGE_MS: 3 * 60 * 1000,
  DECAY_MIN_POINTS: 0.5,
};

export const REFERENTIAL_TYPES = {
  PROJECTS_LIST_COLUMNS: "PROJECTS_LIST_COLUMNS",
};

export const PROJECTS_LIST_COLUMNS = {
  AVATAR: "AVATAR",
  CLIENT: "CLIENT",
  PHONE: "PHONE",
  CALLS_COUNT: "CALLS_COUNT",
  OFFER: "OFFER",
  STATUS: "STATUS",
  LAST_ACTION: "LAST_ACTION",
  LAST_SIGNAL: "LAST_SIGNAL",
  CREATION_DATE: "CREATION_DATE",
  ADVISOR: "ADVISOR",
  LOCK: "LOCK",
  ACTIONS: "ACTIONS",
};

export const PROJECTS_LIST_LOCKED_COLUMNS = [
  PROJECTS_LIST_COLUMNS.AVATAR,
  PROJECTS_LIST_COLUMNS.CLIENT,
  PROJECTS_LIST_COLUMNS.ACTIONS,
];

export const AUTH_PROVIDERS = {
  KAYROS_ID: "KAYROS_ID",
  ZITADEL: "ZITADEL",
};

export const USER_TYPES = {
  ADMIN: {
    type: "admin",
    index: SCREENS.PRIVATE.ADMIN.ORGANIZATIONS.LIST.path,
  },
  INSURANCE_ADMIN: {
    type: "admin.insurance",
    index: SCREENS.PRIVATE.ADMIN.INSURANCE_PLANS.LIST.path,
  },
  INSURANCE_EMPLOYEE: {
    type: "employee.insurance",
    index: SCREENS.PRIVATE.BROKER.PROJECTS.LIST.path,
  },
  INSURANCE_REPRESENTATIVE: {
    type: "representative.insurance",
    index: SCREENS.PRIVATE.BROKER.PROJECTS.LIST.path,
  },
  BROKER_DASHBOARD: {
    type: "broker.dashboard",
    index: SCREENS.PRIVATE.BROKER.DASHBOARD.path,
  },
  BROKER_ADMIN: {
    type: "admin.broker",
    index: SCREENS.PRIVATE.BROKER.PROJECTS.LIST.path,
  },
  BROKER_EMPLOYEE: {
    type: "employee.broker",
    index: SCREENS.PRIVATE.BROKER.PROJECTS.LIST.path,
  },
  BROKER_REPRESENTATIVE: {
    type: "representative.broker",
    index: SCREENS.PRIVATE.BROKER.PROJECTS.LIST.path,
  },
  INTERNAL_SUPERVISOR: {
    type: "supervisor.internal",
    index: SCREENS.PRIVATE.BROKER.PROJECTS.LIST.path,
  },
  INTERNAL_ADVISOR: {
    type: "advisor.internal",
    index: SCREENS.PRIVATE.BROKER.PROJECTS.LIST.path,
  },
  INSURANCE_GUEST: {
    type: "guest.insurance",
    index: SCREENS.AUTH.LOGOUT.path,
  },
  EXTERNAL_ADVISOR: {
    type: "advisor.external",
    index: SCREENS.AUTH.NOT_AUTHORIZED.path,
  },
  HUMAN_RESOURCE: {
    type: "human.resource",
    index: SCREENS.AUTH.NOT_AUTHORIZED.path,
  },
  CONTRACT_GUEST: {
    type: "guest.contract",
    index: SCREENS.AUTH.LOGOUT.path,
  },
};

export const MODULES = {
  DASHBOARD: "DASHBOARD",
  SOURCE: "SOURCE",
  TRACER: "TRACER",
  FLOW: "FLOW",
  USER: "USER",
  PROCESS: "PROCESS",
  PROCESS_STATUS: "PROCESS_STATUS",
  INSURANCE_PLAN: "INSURANCE_PLAN",
  COVERAGE: "COVERAGE",
  COVERAGE_BENEFIT: "COVERAGE_BENEFIT",
  SUBSCRIPTION: "SUBSCRIPTION",
  ORGANIZATION: "ORGANIZATION",
  QUALIFICATION: "QUALIFICATION",
  QUALIFIER: "QUALIFIER",
  WEBHOOK: "WEBHOOK",
  COLLABORATORS: "COLLABORATORS",
  PROJECT: "PROJECT",
  GENERAL_COST: "GENERAL_COST",
  CONTRACT: "CONTRACT",
  CONTACT: "CONTACT",
  REMINDER: "REMINDER",
  NOTE: "NOTE",
  BROKER: "BROKER",
  WORKFLOW: "WORKFLOW",
  PRICER: "PRICER",
  COMMISSION_STATEMENT: "COMMISSION_STATEMENT",
  COMMISSION: "COMMISSION",
  COVERAGE_CATEGORY: "COVERAGE_CATEGORY",
  PRODUCT_RANGE: "PRODUCT_RANGE",
  OFFER: "OFFER",
  MODEL: "MODEL",
  BRAND: "BRAND",
  STORE: "STORE",
  NOTIFICATION: "NOTIFICATION",
  CAMPAIGN: "CAMPAIGN",
  TASK: "TASK",
  COMPANY: "COMPANY",
  EMAIL: "EMAIL",
  DYNAMIC_DOCUMENTS: "DYNAMIC_DOCUMENTS",
  SCREEN_STUDIO: "SCREEN_STUDIO",
  DISPATCHER: "DISPATCHER",
};

export const DISPATCH_ROUTES = {
  PROJECT_CREATE: "PROJECT_CREATE",
  LEAD_CREATE: "LEAD_CREATE",
  PRICER_CALCULATE: "PRICER_CALCULATE",
};

export const SUBMODULES = {
  ADMIN_LIST: "ADMIN_LIST",
  ADMIN_CREATE: "ADMIN_CREATE",
  ADMIN_DETAIL: "ADMIN_DETAIL",
  ADMIN_EDIT: "ADMIN_EDIT",
  ADMIN_DELETE: "ADMIN_DELETE",
  ADMIN_SHOW: "ADMIN_SHOW",
  BROKER_LIST: "BROKER_LIST",
  BROKER_CREATE: "BROKER_CREATE",
  BROKER_DETAIL: "BROKER_DETAIL",
  BROKER_DELETE: "BROKER_DELETE",
  BROKER_IDENTIFY: "BROKER_IDENTIFY",
  BROKER_SHOW: "BROKER_SHOW",
};

export const ACTIONS = {
  DASHBOARD: "dashboard",
  SOURCES: "sources",
  DELETE_SOURCE: "deleteSource",
  ADD_SOURCE: "addSource",
  SOURCE: "source",
  UPDATE_SOURCE: "updateSource",
  TRACERS: "tracers",
  DELETE_TRACER: "deleteTracer",
  ADD_TRACER: "addTracer",
  TRACER: "tracer",
  UPDATE_TRACER: "updateTracer",
  FLOWS: "flows",
  DELETE_FLOW: "deleteFlow",
  ADD_FLOW: "addFlow",
  FLOW: "flow",
  UPDATE_FLOW: "updateFlow",
  USERS: "users",
  DELETE_USER: "deleteUser",
  ADD_USER: "addUser",
  USER: "user",
  UPDATE_USER: "updateUser",
  PROCESSES: "processes",
  DELETE_PROCESS: "deleteProcess",
  ADD_PROCESS: "addProcess",
  PROCESS: "process",
  UPDATE_PROCESS: "updateProcess",
  DELETE_COVERAGE: "deleteCoverage",
  ADD_COVERAGE: "addCoverage",
  COVERAGES: "coverages",
  COVERAGE: "coverage",
  UPDATE_COVERAGE: "updateCoverage",
  COVERAGE_BENEFITS: "coverageBenefits",
  DELETE_COVERAGE_BENEFIT: "deleteCoverageBenefit",
  ADD_COVERAGE_BENEFIT: "addCoverageBenefit",
  COVERAGE_BENEFIT: "coverageBenefit",
  UPDATE_COVERAGE_BENEFIT: "updateCoverageBenefit",
  SUBSCRIPTION: "subscription",
  UPDATE_SUBSCRIPTION: "updateSubscription",
  SEND_SUBSCRIPTION_ATTACHMENTS: "sendSubscriptionAttachments",
  DOWNLOAD_SUBSCRIPTION_ATTACHMENTS: "downloadSubscriptionAttachments",
  EXPORT_SUBSCRIPTIONS: "exportSubscriptions",
  DEPOSIT_CIBLEMUT: "depositAmellisCiblemutSftp",
  SEND_TO_MANAGEMENT: "sendToManagement",
  QUALIFICATIONS: "qualifications",
  DELETE_QUALIFICATION: "deleteQualification",
  ADD_QUALIFICATION: "addQualification",
  QUALIFICATION: "qualification",
  UPDATE_QUALIFICATION: "updateQualification",
  ORGANIZATIONS: "organizations",
  DELETE_ORGANIZATION: "deleteOrganization",
  ADD_ORGANIZATION: "addOrganization",
  ORGANIZATION: "organization",
  UPDATE_ORGANIZATION: "updateOrganization",
  BROKERS: "brokers",
  DELETE_BROKER: "deleteBroker",
  ADD_BROKER: "addBroker",
  BROKER: "broker",
  UPDATE_BROKER: "updateBroker",
  NOTES: "notes",
  ADD_NOTE: "addNote",
  QUALIFIERS: "qualifiers",
  DELETE_QUALIFIER: "deleteQualifier",
  ADD_QUALIFIER: "addQualifier",
  QUALIFIER: "qualifier",
  UPDATE_QUALIFIER: "updateQualifier",
  WEBHOOKS: "webhooks",
  DUPLICATE_PROJECT: "duplicateProject",
  DELETE_PROJECT: "deleteProject",
  ADD_PROJECT: "addProject",
  PROJECT: "project",
  PROJECTS: "projects",
  UPDATE_PROJECT: "updateProject",
  ASSIGN_PROJECT: "assignProject",
  GENERAL_COSTS: "generalCosts",
  CONTRACTS: "contracts",
  DELETE_CONTRACT: "deleteContract",
  ADD_CONTRACT: "addContract",
  CONTRACT: "contract",
  UPDATE_CONTRACT: "updateContract",
  CONTACTS: "contacts",
  DELETE_CONTACT: "deleteContact",
  ADD_CONTACT: "addContact",
  CONTACT: "contact",
  UPDATE_CONTACT: "updateContact",
  REMINDERS: "reminders",
  ADD_REMINDER: "addReminder",
  INSURANCE_PLANS: "insurancePlans",
  INSURANCE_PLAN: "insurancePlan",
  ADD_INSURANCE_PLAN: "addInsurancePlan",
  UPDATE_INSURANCE_PLAN: "updateInsurancePlan",
  DELETE_INSURANCE_PLAN: "deleteInsurancePlan",
  WORKFLOW: "workflow",
  WORKFLOWS: "workflows",
  ADD_WORKFLOW: "addWorkflow",
  UPDATE_WORKFLOW: "updateWorkflow",
  DELETE_WORKFLOW: "deleteWorkflow",
  PRICER: "pricer",
  PRICERS: "pricers",
  ADD_PRICER: "addPricer",
  UPDATE_PRICER: "updatePricer",
  DELETE_PRICER: "deletePricer",
  COMMISSION_STATEMENT: "commissionStatement",
  COMMISSION_STATEMENTS: "commissionStatements",
  ADD_COMMISSION_STATEMENT: "addCommissionStatement",
  UPDATE_COMMISSION_STATEMENT: "updateCommissionStatement",
  DELETE_COMMISSION_STATEMENT: "deleteCommissionStatement",
  DOWNLOAD_SINGLE_DOCUMENT: "downloadSingleDocument",
  COMMISSION: "commission",
  COMMISSIONS: "commissions",
  ADD_COMMISSION: "addCommission",
  UPDATE_COMMISSION: "updateCommission",
  DELETE_COMMISSION: "deleteCommission",
  COVERAGE_CATEGORY: "coverageCAtegory",
  COVERAGE_CATEGORIES: "coverageCAtegories",
  ADD_COVERAGE_CATEGORY: "addCoverageCategory",
  UPDATE_COVERAGE_CATEGORY: "updateCoverageCategory",
  DELETE_COVERAGE_CATEGORY: "deleteCoverageCategory",
  PRODUCT_RANGES: "productRanges",
  PRODUCT_RANGE: "productRange",
  ADD_PRODUCT_RANGE: "addProductRange",
  UPDATE_PRODUCT_RANGE: "updateProductRange",
  DELETE_PRODUCT_RANGE: "deleteProductRange",
  ADD_OFFER: "addOffer",
  UPDATE_OFFER: "updateOffer",
  DELETE_OFFER: "deleteOffer",
  BRAND: "brand",
  BRANDS: "brands",
  ADD_BRAND: "addBrand",
  UPDATE_BRAND: "updateBrand",
  DELETE_BRAND: "deleteBrand",
  MODEL: "model",
  MODELS: "models",
  ADD_MODEL: "addModel",
  UPDATE_MODEL: "updateModel",
  DELETE_MODEL: "deleteModel",
  STORE: "store",
  STORES: "stores",
  ADD_STORE: "addStore",
  UPDATE_STORE: "updateStore",
  DELETE_STORE: "deleteStore",
};

/** Matches subscription.externalManagement.lastSendStatus (API) */
export const SEND_TO_MANAGEMENT_SEND_STATUSES = {
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE",
  SKIPPED: "SKIPPED",
  PENDING: "PENDING",
};

export const PROJECT_TRACKING_FIELD = "tracking";

export const GTM_FIELD_EXECUTOR = "trackGtmEvent";

export const AD_ATTRIBUTION = {
  GCLID_PARAM: "gclid",
  GA_COOKIE: "_ga",
};

export const INSURANCE_PLAN_CONFIG_KEYS = {
  MANAGEMENT_RECIPIENT_EMAIL: "managementRecipientEmail",
};

export const SEND_TO_MANAGEMENT_MODES = {
  MANUAL: "MANUAL",
};

export const PROCESS_TYPES = {
  B2B: "B2B",
  B2C: "B2C",
  COLLECTIVE: "COLLECTIVE",
};

export const TEMPLATE_TYPES = {
  DEFAULT: "DEFAULT",
  B2B_RADIANCE_COSA: "B2B_RADIANCE_COSA",
  B2B_RADIANCE_AURA_TER: "B2B_RADIANCE_AURA_TER",
  B2B_SMART_PHONE: "B2B_SMART_PHONE",
  RADIANCE: "RADIANCE",
  RADIANCE_COSA: "RADIANCE_COSA",
  RADIANCE_AURA_TER: "RADIANCE_AURA_TER",
  B2B_SOLYON: "B2B_SOLYON",
  B2C_SOLYON: "B2C_SOLYON",
  B2C_LMF: "B2C_LMF",
  B2B_LMF: "B2B_LMF",
  B2C_AMELLIS: "B2C_AMELLIS",
  B2B_AMELLIS: "B2B_AMELLIS",
  B2C_COLLECTIVE_AMELLIS: "B2C_COLLECTIVE_AMELLIS",
  B2C_COLLECTIVE_WITH_PRICE_AMELLIS: "B2C_COLLECTIVE_WITH_PRICE_AMELLIS",
  B2B_MUTUAL_MOBILITY: "B2B_MUTUAL_MOBILITY",
  B2C_MUTUAL_MOBILITY: "B2C_MUTUAL_MOBILITY",
  B2B_MILTIS: "B2B_MILTIS",
  B2C_MILTIS: "B2C_MILTIS",
  B2B_MILTIS_TER: "B2B_MILTIS_TER",
  B2C_MILTIS_TER: "B2C_MILTIS_TER",
  B2C_ACORIS: "B2C_ACORIS",
  B2B_ACORIS: "B2B_ACORIS",
  B2B_ACORIS_COLLECTIVE: "B2B_ACORIS_COLLECTIVE",
  B2B_SNCA: "B2B_SNCA",
  B2B_LAFOURGALE: "B2B_LAFOURGALE",
  B2B_MCCI: "B2B_MCCI",
  B2B_DYNAMIC: "B2B_DYNAMIC",
  B2C_DYNAMIC: "B2C_DYNAMIC",
};

export const TEMPLATES = {
  [PROCESS_TYPES.B2B]: {
    THEMES: {
      [TEMPLATE_TYPES.DEFAULT]: {
        CONTACT: "CONTACT",
        COLLECTION_NEEDS: "COLLECTION_NEEDS",
        SELECT_PRODUCTS: "SELECT_PRODUCTS",
        COMPARISON: "COMPARISON",
        QUOTE: "QUOTE",
        SUBSCRIPTION: "SUBSCRIPTION",
        CONTRACT: "CONTRACT",
        PRODUCT_NO_LEVELS: "PRODUCT.NO.LEVELS",
        FAST: "FAST",
      },
      [TEMPLATE_TYPES.B2B_RADIANCE_COSA]: {
        CONTACT: "CONTACT",
        COLLECTION_NEEDS: "COLLECTION_NEEDS",
        SELECT_PRODUCTS: "SELECT_PRODUCTS",
        COMPARISON: "COMPARISON",
        QUOTE: "QUOTE",
        SUBSCRIPTION: "SUBSCRIPTION",
        CONTRACT: "CONTRACT",
        PRODUCT_NO_LEVELS: "PRODUCT.NO.LEVELS",
        FAST: "FAST",
      },
      [TEMPLATE_TYPES.B2B_RADIANCE_AURA_TER]: {
        CONTACT: "CONTACT",
        COLLECTION_NEEDS: "COLLECTION_NEEDS",
        SELECT_PRODUCTS: "SELECT_PRODUCTS",
        COMPARISON: "COMPARISON",
        QUOTE: "QUOTE",
        SUBSCRIPTION: "SUBSCRIPTION",
        CONTRACT: "CONTRACT",
        PRODUCT_NO_LEVELS: "PRODUCT.NO.LEVELS",
        FAST: "FAST",
      },
      [TEMPLATE_TYPES.B2B_SMART_PHONE]: {
        ELIGIBILITY_CHECK: "ELIGIBILITY_CHECK",
        TERMINAL_INFO: "TERMINAL_INFO",
        CONTACT: "CONTACT",
        COMPARISON: "COMPARISON",
        QUOTE: "QUOTE",
        SUBSCRIPTION: "SUBSCRIPTION",
      },
      [TEMPLATE_TYPES.B2B_SOLYON]: {
        CONTACT: "CONTACT",
        COLLECTION_NEEDS: "COLLECTION_NEEDS",
        SELECT_PRODUCTS: "SELECT_PRODUCTS",
        COMPARISON: "COMPARISON",
        QUOTE: "QUOTE",
        SUBSCRIPTION: "SUBSCRIPTION",
        CONTRACT: "CONTRACT",
        UPSELLS: "UPSELLS",
      },
      [TEMPLATE_TYPES.B2B_LMF]: {
        CONTACT: "CONTACT",
        COLLECTION_NEEDS: "COLLECTION_NEEDS",
        SELECT_PRODUCTS: "SELECT_PRODUCTS",
        COMPARISON: "COMPARISON",
        QUOTE: "QUOTE",
        SUBSCRIPTION: "SUBSCRIPTION",
        CONTRACT: "CONTRACT",
        UPSELLS: "UPSELLS",
      },
      [TEMPLATE_TYPES.B2B_AMELLIS]: {
        CONTACT: "CONTACT",
        COLLECTION_NEEDS: "COLLECTION_NEEDS",
        SELECT_PRODUCTS: "SELECT_PRODUCTS",
        COMPARISON: "COMPARISON",
        QUOTE: "QUOTE",
        SUBSCRIPTION: "SUBSCRIPTION",
        CONTRACT: "CONTRACT",
        UPSELLS: "UPSELLS",
      },
      [TEMPLATE_TYPES.B2B_MUTUAL_MOBILITY]: {
        CONTACT: "CONTACT",
        COLLECTION_NEEDS: "COLLECTION_NEEDS",
        SELECT_PRODUCTS: "SELECT_PRODUCTS",
        COMPARISON: "COMPARISON",
        QUOTE: "QUOTE",
        SUBSCRIPTION: "SUBSCRIPTION",
        CONTRACT: "CONTRACT",
        UPSELLS: "UPSELLS",
        SELECT_COMBINATION: "SELECT_COMBINATION",
      },
      [TEMPLATE_TYPES.B2B_MILTIS]: {
        CONTACT: "CONTACT",
        COLLECTION_NEEDS: "COLLECTION_NEEDS",
        SELECT_PRODUCTS: "SELECT_PRODUCTS",
        COMPARISON: "COMPARISON",
        QUOTE: "QUOTE",
        SUBSCRIPTION: "SUBSCRIPTION",
        CONTRACT: "CONTRACT",
      },
      [TEMPLATE_TYPES.B2B_MILTIS_TER]: {
        CONTACT: "CONTACT",
        COLLECTION_NEEDS: "COLLECTION_NEEDS",
        SELECT_PRODUCTS: "SELECT_PRODUCTS",
        COMPARISON: "COMPARISON",
        QUOTE: "QUOTE",
        SUBSCRIPTION: "SUBSCRIPTION",
        CONTRACT: "CONTRACT",
      },
      [TEMPLATE_TYPES.B2B_SNCA]: {
        CONTACT: "CONTACT",
        COLLECTION_NEEDS: "COLLECTION_NEEDS",
        SELECT_PRODUCTS: "SELECT_PRODUCTS",
        COMPARISON: "COMPARISON",
        QUOTE: "QUOTE",
        SUBSCRIPTION: "SUBSCRIPTION",
        CONTRACT: "CONTRACT",
      },
      [TEMPLATE_TYPES.B2B_LAFOURGALE]: {
        CONTACT: "CONTACT",
        SELECT_PRODUCTS: "SELECT_PRODUCTS",
        QUOTE: "QUOTE",
        QUOTE_SENT: "QUOTE_SENT",
      },
      [TEMPLATE_TYPES.B2B_ACORIS_COLLECTIVE]: {
        COMPANY: "COMPANY",
        DEMOGRAPHICS: "DEMOGRAPHICS",
        OFFER: "OFFER",
        SUMMARY: "SUMMARY",
      },
      [TEMPLATE_TYPES.B2B_MCCI]: {
        CONTACT: "CONTACT",
        COLLECTION_NEEDS: "COLLECTION_NEEDS",
        SELECT_PRODUCTS: "SELECT_PRODUCTS",
        COMPARISON: "COMPARISON",
        QUOTE: "QUOTE",
        SUBSCRIPTION: "SUBSCRIPTION",
      },
      [TEMPLATE_TYPES.B2B_ACORIS]: {
        CONTACT: "CONTACT",
        COLLECTION_NEEDS: "COLLECTION_NEEDS",
        SELECT_PRODUCTS: "SELECT_PRODUCTS",
        COMPARISON: "COMPARISON",
        QUOTE: "QUOTE",
        SUBSCRIPTION: "SUBSCRIPTION",
        CONTRACT: "CONTRACT",
        UPSELLS: "UPSELLS",
      },
      [TEMPLATE_TYPES.B2B_DYNAMIC]: {},
    },
  },
  [PROCESS_TYPES.B2C]: {
    THEMES: {
      [TEMPLATE_TYPES.DEFAULT]: {
        GENDER: "GENDER",
        BENEFICIARIES: "BENEFICIARIES",
        CHILDREN_NUMBER: "CHILDREN.NUMBER",
        NEEDS: "NEEDS",
        EFFECTIVE_DATE: "EFFECTIVE.DATE",
        ADHERENT_INFO: "ADHERENT.INFO",
        ADHERENT_SOCIAL_REGIME: "ADHERENT.SOCIAL_REGIME",
        ADHERENT_TELECOMS: "ADHERENT.TELECOMS",
        SPOUSE_BIRTHDATE: "SPOUSE.BIRTHDATE",
        SPOUSE_SOCIAL_REGIME: "SPOUSE.SOCIAL_REGIME",
        CHILDREN_BIRTHDATES: "CHILDREN.BIRTHDATES",
        PRODUCTS: "PRODUCTS",
        B2C_EDIT_SUBSCRIPTION: "B2C_EDIT_SUBSCRIPTION",
        B2C_SUBSCRIPTION_CONTRACT: "B2C_SUBSCRIPTION_CONTRACT",
        B2C_SUBSCRIPTION_DONE: "B2C_SUBSCRIPTION_DONE",
        E_SIGN: "E_SIGN",
        B2C_SUBSCRIPTION: "B2C_SUBSCRIPTION",
      },
      [TEMPLATE_TYPES.RADIANCE]: {
        ADHERENT_INFO: "ADHERENT.INFO",
        ADHERENT_TELECOMS: "ADHERENT.TELECOMS",
        NEEDS: "NEEDS",
        PRODUCTS: "PRODUCTS",
        NO_SUBSCRIPTION: "NO_SUBSCRIPTION",
        CONTACT_US: "CONTACT_US",
        B2C_EDIT_SUBSCRIPTION: "B2C_EDIT_SUBSCRIPTION",
        B2C_SUBSCRIPTION_CONTRACT: "B2C_SUBSCRIPTION_CONTRACT",
        B2C_SUBSCRIPTION_DONE: "B2C_SUBSCRIPTION_DONE",
        B2C_SUBSCRIPTION: "B2C_SUBSCRIPTION",
        JUSTIFICATIONS: "JUSTIFICATIONS",
        E_SIGN: "E_SIGN",
        PAYMENT: "PAYMENT",
      },
      [TEMPLATE_TYPES.RADIANCE_COSA]: {
        ADHERENT_INFO: "ADHERENT.INFO",
        ADHERENT_TELECOMS: "ADHERENT.TELECOMS",
        NEEDS: "NEEDS",
        PRODUCTS: "PRODUCTS",
        NO_SUBSCRIPTION: "NO_SUBSCRIPTION",
        CONTACT_US: "CONTACT_US",
        B2C_EDIT_SUBSCRIPTION: "B2C_EDIT_SUBSCRIPTION",
        B2C_SUBSCRIPTION_CONTRACT: "B2C_SUBSCRIPTION_CONTRACT",
        B2C_SUBSCRIPTION_DONE: "B2C_SUBSCRIPTION_DONE",
        B2C_SUBSCRIPTION: "B2C_SUBSCRIPTION",
        JUSTIFICATIONS: "JUSTIFICATIONS",
        E_SIGN: "E_SIGN",
        PAYMENT: "PAYMENT",
      },
      [TEMPLATE_TYPES.RADIANCE_AURA_TER]: {
        ADHERENT_INFO: "ADHERENT.INFO",
        ADHERENT_TELECOMS: "ADHERENT.TELECOMS",
        NEEDS: "NEEDS",
        PRODUCTS: "PRODUCTS",
        NO_SUBSCRIPTION: "NO_SUBSCRIPTION",
        CONTACT_US: "CONTACT_US",
        B2C_EDIT_SUBSCRIPTION: "B2C_EDIT_SUBSCRIPTION",
        B2C_SUBSCRIPTION_CONTRACT: "B2C_SUBSCRIPTION_CONTRACT",
        B2C_SUBSCRIPTION_DONE: "B2C_SUBSCRIPTION_DONE",
        B2C_SUBSCRIPTION: "B2C_SUBSCRIPTION",
        JUSTIFICATIONS: "JUSTIFICATIONS",
        E_SIGN: "E_SIGN",
        PAYMENT: "PAYMENT",
      },
      [TEMPLATE_TYPES.B2C_SOLYON]: {
        PROFILE: "PROFILE",
        ADHERENT_BIRTHDATE: "ADHERENT.BIRTHDATE",
        INCOME: "INCOME",
        ADHERENT_INFO: "ADHERENT.INFO",
        NEEDS: "NEEDS",
        PRODUCTS: "PRODUCTS",
        UPSELLS: "UPSELLS",
        PROTECT_INCOME: "PROTECT_INCOME",
        CDS: "CDS",
        EFFECTIVE_DATE: "EFFECTIVE_DATE",
        ADHERENT_TELECOMS: "ADHERENT.TELECOMS",
        ADHERENT_SOCIAL_SECURITY_NUMBER: "ADHERENT.SOCIAL.SECURITY.NUMBER",
        RELATED_PERSONS: "RELATED.PERSONS",
        ADHERENT_BANK_INFORMATION: "ADHERENT.BANK.INFORMATION",
        E_SIGN: "E_SIGN",
        JUSTIFICATIONS: "JUSTIFICATIONS",
        RGPD: "RGPD",
        SUBSCRIPTION_DONE: "SUBSCRIPTION_DONE",
        GENERATE_E_SIGN_DOCUMENTS: "GENERATE_E_SIGN_DOCUMENTS",
      },
      [TEMPLATE_TYPES.B2C_LMF]: {
        PROFILE: "PROFILE",
        CONTACT: "CONTACT",
        CONTACT_CSS: "CONTACT_CSS",
        CONTACT_ALREADY_ADHERENT: "CONTACT_ALREADY_ADHERENT",
        COLLECTION_NEEDS: "COLLECTION_NEEDS",
        PRODUCTS: "PRODUCTS",
        ADHERENT_TELECOMS: "ADHERENT.TELECOMS",
        THANK_YOU: "THANK_YOU",
        ADHERENT_DETAILS: "ADHERENT.DETAILS",
        MODULES: "MODULES",
        EFFECTIVE_DATE: "EFFECTIVE_DATE",
        ADDRESS_ADHERENT: "ADDRESS_ADHERENT",
        SOCIAL_SECURITY_NUMBER: "SOCIAL_SECURITY_NUMBER",
        PAYMENT: "PAYMENT",
        JUSTIFICATIONS: "JUSTIFICATIONS",
        SPOUSE_JUSTIFICATIONS: "SPOUSE_JUSTIFICATIONS",
        CHILDREN_JUSTIFICATIONS: "CHILDREN_JUSTIFICATIONS",
        PAYER_JUSTIFICATIONS: "PAYER_JUSTIFICATIONS",
        BENEFICIARIES: "BENEFICIARIES",
        CONTRACT: "CONTRACT",
        E_SIGN: "E_SIGN",
        BANK_CARD: "BANK_CARD",
        SUBSCRIPTION_DONE: "SUBSCRIPTION_DONE",
      },
      [TEMPLATE_TYPES.B2C_AMELLIS]: {
        PROFILE: "PROFILE",
        SELECT_BRANCH: "SELECT_BRANCH",
        SELECT_COLLECTIVITY: "SELECT_COLLECTIVITY",
        ADHERENT_BIRTHDATE: "ADHERENT.BIRTHDATE",
        INCOME: "INCOME",
        ADHERENT_INFO: "ADHERENT.INFO",
        NEEDS: "NEEDS",
        PRODUCTS: "PRODUCTS",
        PRODUCTS_WITHOUT_PRICE: "PRODUCTS_WITHOUT_PRICE",
        PRODUCTS_PER_BENEFICIARY_WITHOUT_PRICE:
          "PRODUCTS_PER_BENEFICIARY_WITHOUT_PRICE",
        PRODUCTS_PRICE_PER_BENEFICIARY: "PRODUCTS_PRICE_PER_BENEFICIARY",
        UPSELLS: "UPSELLS",
        PROTECT_INCOME: "PROTECT_INCOME",
        EFFECTIVE_DATE: "EFFECTIVE_DATE",
        ADHERENT_TELECOMS: "ADHERENT.TELECOMS",
        ADHERENT_SOCIAL_SECURITY_NUMBER: "ADHERENT.SOCIAL.SECURITY.NUMBER",
        RELATED_PERSONS: "RELATED.PERSONS",
        ADHERENT_BANK_INFORMATION: "ADHERENT.BANK.INFORMATION",
        ADHERENT_BANK_INFORMATION_WITHOUT_PAYMENT:
          "ADHERENT.BANK.INFORMATION_WITHOUT_PAYMENT",
        ADHERENT_BANK_INFORMATION_BENEFICIARY_COVERAGE:
          "ADHERENT.BANK.INFORMATION_BENEFICIARY_COVERAGE",
        ADHERENT_BANK_INFORMATION_FAMILY_COVERAGE:
          "ADHERENT.BANK.INFORMATION_FAMILY_COVERAGE",
        GENERATE_E_SIGN_DOCUMENTS: "GENERATE_E_SIGN_DOCUMENTS",
        GENERATE_E_SIGN_DOCUMENTS_WITH_REQUIRED_NOTICE:
          "GENERATE_E_SIGN_DOCUMENTS_WITH_REQUIRED_NOTICE",
        E_SIGN: "E_SIGN",
        JUSTIFICATIONS: "JUSTIFICATIONS",
        SPOUSE_JUSTIFICATIONS: "SPOUSE_JUSTIFICATIONS",
        CHILDREN_JUSTIFICATIONS: "CHILDREN_JUSTIFICATIONS",
        RGPD: "RGPD",
        SUBSCRIPTION_DONE: "SUBSCRIPTION_DONE",
      },
      [TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY]: {
        ADHERENT_BIRTHDATE: "ADHERENT.BIRTHDATE",
        ADHERENT_BIRTHDATE_RENAULT_EMPLOYEE:
          "ADHERENT.BIRTHDATE.RENAULT.SALARY",
        INCOME: "INCOME",
        ADHERENT_INFO: "ADHERENT.INFO",
        NEEDS: "NEEDS",
        PRODUCTS: "PRODUCTS",
        UPSELLS: "UPSELLS",
        PROTECT_INCOME: "PROTECT_INCOME",
        EFFECTIVE_DATE: "EFFECTIVE_DATE",
        ADHERENT_TELECOMS: "ADHERENT.TELECOMS",
        ADHERENT_SOCIAL_SECURITY_NUMBER: "ADHERENT.SOCIAL.SECURITY.NUMBER",
        RELATED_PERSONS: "RELATED.PERSONS",
        ADHERENT_BANK_INFORMATION: "ADHERENT.BANK.INFORMATION",
        SELECT_COMBINATION: "SELECT_COMBINATION",
        E_SIGN: "E_SIGN",
        JUSTIFICATIONS: "JUSTIFICATIONS",
        SPOUSE_JUSTIFICATIONS: "SPOUSE_JUSTIFICATIONS",
        CHILDREN_JUSTIFICATIONS: "CHILDREN_JUSTIFICATIONS",
        RGPD: "RGPD",
        SUBSCRIPTION_DONE: "SUBSCRIPTION_DONE",
        GENERATE_E_SIGN_DOCUMENTS: "GENERATE_E_SIGN_DOCUMENTS",
      },
      [TEMPLATE_TYPES.B2C_MILTIS]: {
        ADHERENT_BIRTHDATE: "ADHERENT.BIRTHDATE",
        ADHERENT_INFO: "ADHERENT.INFO",
        NEEDS: "NEEDS",
        PRODUCTS: "PRODUCTS",
        UPSELLS: "UPSELLS",
        PROTECT_INCOME: "PROTECT_INCOME",
        EFFECTIVE_DATE: "EFFECTIVE_DATE",
        ADHERENT_TELECOMS: "ADHERENT.TELECOMS",
        ADHERENT_SOCIAL_SECURITY_NUMBER: "ADHERENT.SOCIAL.SECURITY.NUMBER",
        RELATED_PERSONS: "RELATED.PERSONS",
        ADHERENT_BANK_INFORMATION: "ADHERENT.BANK.INFORMATION",
        GENERATE_E_SIGN_DOCUMENTS: "GENERATE_E_SIGN_DOCUMENTS",
        E_SIGN: "E_SIGN",
        JUSTIFICATIONS: "JUSTIFICATIONS",
        JUSTIFICATIONS_AFTER_SIGN: "JUSTIFICATIONS_AFTER_SIGN",
        SPOUSE_JUSTIFICATIONS: "SPOUSE_JUSTIFICATIONS",
        CHILDREN_JUSTIFICATIONS: "CHILDREN_JUSTIFICATIONS",
        SUBSCRIPTION_DONE: "SUBSCRIPTION_DONE",
      },
      [TEMPLATE_TYPES.B2C_ACORIS]: {
        PROFILE: "PROFILE",
        ADHERENT_BIRTHDATE: "ADHERENT.BIRTHDATE",
        CONTACT_ADVISOR: "CONTACT_ADVISOR",
        CONTACT_SUCCESS: "CONTACT_SUCCESS",
        ADHERENT_INFO: "ADHERENT.INFO",
        NEEDS: "NEEDS",
        PRODUCTS: "PRODUCTS",
        UPSELLS: "UPSELLS",
        PACKS: "PACKS",
        PROTECT_INCOME: "PROTECT_INCOME",
        EFFECTIVE_DATE: "EFFECTIVE_DATE",
        ADHERENT_TELECOMS: "ADHERENT.TELECOMS",
        ADHERENT_SOCIAL_SECURITY_NUMBER: "ADHERENT.SOCIAL.SECURITY.NUMBER",
        RELATED_PERSONS: "RELATED.PERSONS",
        ADHERENT_BANK_INFORMATION: "ADHERENT.BANK.INFORMATION",
        PAYMENT: "PAYMENT",
        GENERATE_E_SIGN_DOCUMENTS: "GENERATE_E_SIGN_DOCUMENTS",
        E_SIGN: "E_SIGN",
        E_SIGN_YOUSIGN: "E_SIGN_YOUSIGN",
        JUSTIFICATIONS: "JUSTIFICATIONS",
        JUSTIFICATIONS_AFTER_SIGN: "JUSTIFICATIONS_AFTER_SIGN",
        SPOUSE_JUSTIFICATIONS: "SPOUSE_JUSTIFICATIONS",
        CHILDREN_JUSTIFICATIONS: "CHILDREN_JUSTIFICATIONS",
        SUBSCRIPTION_DONE: "SUBSCRIPTION_DONE",
      },
      [TEMPLATE_TYPES.B2C_MILTIS_TER]: {
        ADHERENT_BIRTHDATE: "ADHERENT.BIRTHDATE",
        ADHERENT_INFO: "ADHERENT.INFO",
        NEEDS: "NEEDS",
        PRODUCTS: "PRODUCTS",
        UPSELLS: "UPSELLS",
        PROTECT_INCOME: "PROTECT_INCOME",
        EFFECTIVE_DATE: "EFFECTIVE_DATE",
        ADHERENT_TELECOMS: "ADHERENT.TELECOMS",
        ADHERENT_SOCIAL_SECURITY_NUMBER: "ADHERENT.SOCIAL.SECURITY.NUMBER",
        RELATED_PERSONS: "RELATED.PERSONS",
        ADHERENT_BANK_INFORMATION: "ADHERENT.BANK.INFORMATION",
        GENERATE_E_SIGN_DOCUMENTS: "GENERATE_E_SIGN_DOCUMENTS",
        E_SIGN: "E_SIGN",
        JUSTIFICATIONS: "JUSTIFICATIONS",
        JUSTIFICATIONS_AFTER_SIGN: "JUSTIFICATIONS_AFTER_SIGN",
        SPOUSE_JUSTIFICATIONS: "SPOUSE_JUSTIFICATIONS",
        CHILDREN_JUSTIFICATIONS: "CHILDREN_JUSTIFICATIONS",
        SUBSCRIPTION_DONE: "SUBSCRIPTION_DONE",
      },
      [TEMPLATE_TYPES.B2C_DYNAMIC]: {
        DYNAMIC: "DYNAMIC",
      },
    },
  },
  [PROCESS_TYPES.COLLECTIVE]: {
    THEMES: {
      [TEMPLATE_TYPES.B2C_COLLECTIVE_AMELLIS]: {
        PROFILE: "PROFILE",
        SELECT_BRANCH: "SELECT_BRANCH",
        ADHERENT_BIRTHDATE: "ADHERENT.BIRTHDATE",
        INCOME: "INCOME",
        ADHERENT_INFO: "ADHERENT.INFO",
        NEEDS: "NEEDS",
        PRODUCTS: "PRODUCTS",
        UPSELLS: "UPSELLS",
        PROTECT_INCOME: "PROTECT_INCOME",
        EFFECTIVE_DATE: "EFFECTIVE_DATE",
        ADHERENT_TELECOMS: "ADHERENT.TELECOMS",
        ADHERENT_SOCIAL_SECURITY_NUMBER: "ADHERENT.SOCIAL.SECURITY.NUMBER",
        RELATED_PERSONS: "RELATED.PERSONS",
        ADHERENT_BANK_INFORMATION: "ADHERENT.BANK.INFORMATION",
        E_SIGN: "E_SIGN",
        JUSTIFICATIONS: "JUSTIFICATIONS",
        RGPD: "RGPD",
        SUBSCRIPTION_DONE: "SUBSCRIPTION_DONE",
        GENERATE_E_SIGN_DOCUMENTS: "GENERATE_E_SIGN_DOCUMENTS",
      },
      [TEMPLATE_TYPES.B2C_COLLECTIVE_WITH_PRICE_AMELLIS]: {
        PROFILE: "PROFILE",
        SELECT_BRANCH: "SELECT_BRANCH",
        ADHERENT_BIRTHDATE: "ADHERENT.BIRTHDATE",
        INCOME: "INCOME",
        ADHERENT_INFO: "ADHERENT.INFO",
        NEEDS: "NEEDS",
        PRODUCTS: "PRODUCTS",
        PRODUCTS_PRICE_PER_BENEFICIARY: "PRODUCTS_PRICE_PER_BENEFICIARY",
        UPSELLS: "UPSELLS",
        PROTECT_INCOME: "PROTECT_INCOME",
        EFFECTIVE_DATE: "EFFECTIVE_DATE",
        ADHERENT_TELECOMS: "ADHERENT.TELECOMS",
        ADHERENT_SOCIAL_SECURITY_NUMBER: "ADHERENT.SOCIAL.SECURITY.NUMBER",
        RELATED_PERSONS: "RELATED.PERSONS",
        ADHERENT_BANK_INFORMATION: "ADHERENT.BANK.INFORMATION",
        ADHERENT_BANK_INFORMATION_WITHOUT_PAYMENT:
          "ADHERENT.BANK.INFORMATION_WITHOUT_PAYMENT",
        ADHERENT_BANK_INFORMATION_BENEFICIARY_COVERAGE:
          "ADHERENT.BANK.INFORMATION_BENEFICIARY_COVERAGE",
        ADHERENT_BANK_INFORMATION_FAMILY_COVERAGE:
          "ADHERENT.BANK.INFORMATION_FAMILY_COVERAGE",
        E_SIGN: "E_SIGN",
        JUSTIFICATIONS: "JUSTIFICATIONS",
        RGPD: "RGPD",
        SUBSCRIPTION_DONE: "SUBSCRIPTION_DONE",
        GENERATE_E_SIGN_DOCUMENTS: "GENERATE_E_SIGN_DOCUMENTS",
      },
    },
  },
};

export const CONTACT_TYPES = {
  NEW: "NEW",
  NO_ANSWER: "NO_ANSWER",
  WRONG_NUMBER: "WRONG_NUMBER",
  WON: "WON",
  DUPLICATED: "DUPLICATED",
  QUOTE_SENT: "QUOTE_SENT",
};

export const MOMENT_UNITS_IN_MINUTES = {
  ONE_HOUR: 60,
};

export const COVERAGE_CATEGORIES = {
  HOSPITALIZATION: "HOSPITALIZATION",
  MATERNITY: "MATERNITY",
  DENTAL: "DENTAL",
  MEDICAL_CARE: "MEDICAL_CARE",
  EQUIPMENT: "EQUIPMENT",
  ALTERNATIVE_MEDICINE: "ALTERNATIVE_MEDICINE",
  PREVENTION: "PREVENTION",
  OTHER: "OTHER",
  OPTICAL: "OPTICAL",
};

export const COVERAGE_NEEDS = {
  HOSPITALIZATION: "hospitalization",
  DENTAL: "dental",
  OPTICAL: "optical",
  MEDICAL_CARE: "medicalExpenses",
  ALTERNATIVE_MEDICINE: "alternativeMedicine",
  EQUIPMENT: "hearingAid",
};

export const SUPPORTING_INFORMATION_CATEGORIES = {
  BASE_REFUND: "BASE_REFUND",
  CONTEXT: "CONTEXT",
  PRACTICAL_CASES: "PRACTICAL_CASES",
  REINFORCEMENT: "REINFORCEMENT",
  DESCRIPTION: "DESCRIPTION",
  BONUS: "BONUS",
  INCLUDED: "INCLUDED",
  EXCLUDED: "EXCLUDED",
  REIMBURSEMENT: "REIMBURSEMENT",
  LIMIT: "LIMIT",
  HEADLIGHT_WARRANTY: "HEADLIGHT_WARRANTY",
};

export const DEFAUlT_PAGINATION = {
  take: 3,
  skip: 0,
};

export const CURRENCY_SYMBOL = {
  EUR: "€",
  USD: "$",
  XPF: "XPF",
  PMSS: "% PMSS",
  DEFAULT: "",
};

export const COVERAGE_LIMIT_CATEGORIES = {
  COST: "COST",
  COST_PER_YEAR: "COST_PER_YEAR",
  BASE_REFUND: "BASE_REFUND",
  REAL_COSTS: "REAL_COSTS",
  INTEGRAL_RBT: "INTEGRAL_RBT",
  TEXT: "TEXT",
};

export const SUBSCRIPTION_FORM_KEYS = {
  ADDITIONAL_INFORMATION: {
    ADHERENT: "ADHERENT",
    ACTIVITY: "ACTIVITY",
    LAFPAC_MEMBERSHIP: "LAFPAC_MEMBERSHIP",
    CONTACT: "CONTACT",
    PARTNER: "PARTNER",
    CHILDREN: "CHILDREN",
    PAYMENT: "PAYMENT",
    REFUND: "REFUND",
    CONTRACT: "CONTRACT",
    TERMINAL: "TERMINAL",
    SUBSCRIBER: "SUBSCRIBER",
    TERMINATION_REQUEST: "TERMINATION_REQUEST",
    BROKERAGE_MANDATE: "BROKERAGE_MANDATE",
    INFORMATION: "INFORMATION",
    LEGAL_PROTECTION: "LEGAL_PROTECTION",
    BENEFICIARY: "BENEFICIARY",
    PPE: "PPE",
    SPONSORSHIP_MEMBERSHIP: "SPONSORSHIP_MEMBERSHIP",
    ADVANTAGES: "ADVANTAGES",
    CONSENTS: "CONSENTS",
    MARKETING_CONSENTS: "MARKETING_CONSENTS",
    DATA_PROTECTION: "DATA_PROTECTION",
  },
  PROOF: {
    ID: "ID",
    KBIS: "KBIS",
    PAYER: "PAYER",
    SPOUSE: "SPOUSE",
    CHILDREN: "CHILDREN_DOCUMENTS",
    ADHERENT: "ADHERENT_DOCUMENTS",
    PAY_SLIP: "PAY_SLIP",
    TAX_NOTICE: "TAX_NOTICE",
    BANK_ACCOUNT: "BANK_ACCOUNT",
    PAYER_RIB: "PAYER_RIB",
    RECEIVER_RIB: "RECEIVER_RIB",
    PROOF_OF_ADDRESS: "PROOF_OF_ADDRESS",
    PROFESSIONAL_BANK_ACCOUNT: "PROFESSIONAL_BANK_ACCOUNT",
    PENSION_FUND: "PENSION_FUND",
    SOCIAL_SECURITY_CERTIFICATE: "SOCIAL_SECURITY_CERTIFICATE",
    MARITAL_CERTIFICATE: "MARITAL_CERTIFICATE",
    ELECTRONIC_SIGNATURE_ELIGIBILITY: "ELECTRONIC_SIGNATURE_ELIGIBILITY",
    ENROLLMENT_CERTIFICATE: "ENROLLMENT_CERTIFICATE",
    COMMUNITY_ATTACHMENT: "COMMUNITY_ATTACHMENT",
    HEALTH_INSURANCE_RIGHTS_CERTIFICATE: "HEALTH_INSURANCE_RIGHTS_CERTIFICATE",
    SUPPORTING_DOCUMENTS: "SUPPORTING_DOCUMENTS",
    SPOUSE_ATTESTATION: "SPOUSE_ATTESTATION",
    CHILDREN_ATTESTATION: "CHILDREN_ATTESTATION",
    TERRITORIAL_COLLECTIVITY_ATTESTATION:
      "TERRITORIAL_COLLECTIVITY_ATTESTATION",
    CNRACL_IRCANTEC_AFFILIATION: "CNRACL_IRCANTEC_AFFILIATION",
    EMANCIPATION_CERTIFICATE: "EMANCIPATION_CERTIFICATE",
    LEGAL_REPRESENTATIVE_PROOF: "LEGAL_REPRESENTATIVE_PROOF",
    PROOF_OF_ELIGIBILITY: "PROOF_OF_ELIGIBILITY",
    CONTRIBUTION_PAYMENT_AGREEMENT: "CONTRIBUTION_PAYMENT_AGREEMENT",
    STUDENT_CERTIFICATE: "STUDENT_CERTIFICATE",
  },
  SIGNATURE: {
    E_SIGNATURE: "E_SIGNATURE",
    DOCUMENTS: "DOCUMENTS",
  },
};

export const ANSET_SUBSCRIPTION_FORM_KEYS = {
  ADDITIONAL_INFORMATION: {
    CONTRACT: "CONTRACT",
    ADHERENT: "ADHERENT",
    CONTACT: "CONTACT",
    PAYMENT: "PAYMENT",
    TERMINAL: "TERMINAL",
    SUBSCRIBER: "SUBSCRIBER",
  },
  PROOF: {
    PURCHASE_INVOICE: "PURCHASE_INVOICE",
    PROOF_OF_RESIDENCE: "PROOF_OF_RESIDENCE",
    ID: "ID",
    BANK_ACCOUNT: "BANK_ACCOUNT",
    SUPPORTING_DOCUMENTS: "SUPPORTING_DOCUMENTS",
  },
  SIGNATURE: {
    E_SIGNATURE: "E_SIGNATURE",
    DOCUMENTS: "DOCUMENTS",
  },
};

export const GENDER = {
  MALE: "M",
  FEMALE: "F",
};

export const AUTHORITY_TYPE = {
  FATHER: "FATHER",
  MOTHER: "MOTHER",
  BOTH: "BOTH",
  SELF: "SELF",
};

/** Parent whose NIR is copied when child authority is BOTH (Miltis). */
export const NIR_INHERITANCE_FROM = {
  ADHERENT: "ADHERENT",
  SPOUSE: "SPOUSE",
};

export const RELATIONSHIP = {
  CHILD: "CHILD",
  SPOUSE: "SPOUSE",
  OTHER: "OTHER",
};

export const BOOLEAN = {
  true: true,
  false: false,
};

export const ORGANIZATION_TYPES = {
  PROV: "PROV",
  DEPT: "DEPT",
  TEAM: "TEAM",
  GOVT: "GOVT",
  INS: "INS",
  PAY: "PAY",
  EDU: "EDU",
  RELI: "RELI",
  CRS: "CRS",
  CG: "CG",
  BUS: "BUS",
  BROKER: "BROKER",
  CDG: "CDG",
  MUN: "MUN",
  OTHER: "OTHER",
};

export const ORGANIZATION_HOSTINGS = {
  INTERNAL: "INTERNAL",
  EXTERNAL: "EXTERNAL",
};

export const ORGANIZATION_DUPLICABLE_ENTITIES = [
  "INSURANCE_PLANS",
  "PRICERS",
  "OFFERS",
  "PROCESSES",
  "SOURCES",
  "TRACERS",
  "COVERAGE_CATEGORIES",
  "COVERAGE_BENEFITS",
];

export const ORGANIZATION_FORMS = {
  PROFESSIONAL_CIVIL_COMPANY: "PROFESSIONAL_CIVIL_COMPANY",
  GIE: "GIE",
  LIMITED_PARTNERSHIP: "LIMITED_PARTNERSHIP",
  SOLE_PROPRIETORSHIP: "SOLE_PROPRIETORSHIP",
  SIMPLIFIED_JOINT_STOCK_COMPANY: "SIMPLIFIED_JOINT_STOCK_COMPANY",
  GENERAL_PARTNERSHIP: "GENERAL_PARTNERSHIP",
  EURL: "EURL",
  SELCA: "SELCA",
  SELAFA: "SELAFA",
  PUBLIC_LIMITED_COMPANY: "PUBLIC_LIMITED_COMPANY",
  SARL: "SARL",
  LIMITED_PARTNERSHIP_WITH_SHARES: "LIMITED_PARTNERSHIP_WITH_SHARES",
  PROFESSIONAL_LIBERAL_COMPANY: "PROFESSIONAL_LIBERAL_COMPANY",
  SINGLE_MEMBER_JOINT_STOCK_COMPANY: "SINGLE_MEMBER_JOINT_STOCK_COMPANY",
  SELARL: "SELARL",
  CIVIL_COMPANY_FOR_SHARED_PROFESSIONAL_SERVICES:
    "CIVIL_COMPANY_FOR_SHARED_PROFESSIONAL_SERVICES",
  SINGLE_MEMBER_LIBERAL_COMPANY: "SINGLE_MEMBER_LIBERAL_COMPANY",
  PARTNERSHIP: "PARTNERSHIP",
};

export const DATE_FORMAT = "DD/MM/YYYY";
export const DATE_STRING_FORMAT = "DD MMMM YYYY";
export const API_DATE_FORMAT = "YYYY-MM-DD";
export const API_DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const DATE_TIME_FORMAT = "DD/MM/YYYY HH:mm";
export const TIME_FORMAT = "HH:mm:ss";

export const RISKS = [
  "2-WHEELERS",
  "CROP_INSURANCE",
  "ALL-RISKS_CONSTRUCTION_INSURANCE",
  "SCOOTER_INSURANCE",
  "BIKE_INSURANCE",
  "LIFE_INSURANCE",
  "CAR",
  "OTHER",
  "BOATS",
  "MACHINE_BREAKDOWN",
  "CARAVANS",
  "CREDIT",
  "CYBER_RISKS",
  "DEATH",
  "TAX_DEFERRAL",
  "DEPENDENCE",
  "WORKS_DAMAGE_INSURANCE",
  "BORROWER",
  "CAR_FLEET",
  "FUNERAL_EXPENSES",
  "OVERHEADS",
  "FINANCIAL_GUARANTEE_FOR_COMPLETION",
  "HEALTH_CASH_PLAN",
  "KEY_MAN",
  "GROUP_INSURANCE_FOR_SMALL_BUSINESSES",
  "BUILDING",
  "REAL_ESTATE_INVESTMENT",
  "UNPAID_RENT / RENTAL_RISK",
  "TRANSPORTED_GOODS",
  "HR",
  "PROFESSIONAL_LIABILITY_INSURANCE",
  "ART_OBJECTS_AND_COLLECTIONS",
  "PERSONAL_PENSION_ACCOUNT",
  "EMPLOYEE_SAVINGS_PLAN",
  "INDIVIDUAL_RETIREMENT_PLAN",
  "BUSINESS_INTERRUPTION",
  "GROUP_INSURANCE_FOR_NON-PROFIT_ORGANIZATIONS",
  "GROUP_INSURANCE",
  "SELF-EMPLOYED_INSURANCE",
  "LEGAL_PROTECTION_FOR_PRIVATE_LIFE",
  "LEGAL_PROTECTION_FOR_PROFESSIONALS",
  "FRANCHISE_BUYBACK",
  "HUNTING_LIABILITY_INSURANCE",
  "DECENNIAL_LIABILITY_INSURANCE",
  "MEDICAL_LIABILITY_INSURANCE",
  "ORGANIZATION_LIABILITY_INSURANCE",
  "PROFESSIONAL_LIABILITY_INSURANCE",
  "PRIVATE_LIFE",
  "EDUCATION_ANNUITY",
  "LIFE_ANNUITY",
  "DIRECTORS'_LIABILITY",
  "RETIREMENT_PLAN_83",
  "MADELIN_RETIREMENT_PLAN",
  "HEALTH_INSURANCE_FOR_ACTIVE_PEOPLE",
  "ANIMAL_HEALTH_INSURANCE",
  "GROUP_HEALTH_INSURANCE",
  "HEALTH_INSURANCE_FOR_SENIORS",
  "HEALTH_INSURANCE_FOR_THE_SELF-EMPLOYED",
  "SCHOOL_INSURANCE",
  "TRAVEL_INSURANCE",
];

export const CLIENT_CATEGORY = {
  PARTICULAR: "PARTICULAR",
  PROFESSIONAL: "PROFESSIONAL",
  TNS: "TNS",
  TERRITORIAL_AGENT: "TERRITORIAL_AGENT",
  BUSINESS_LEADER: "BUSINESS_LEADER",
};

export const CLIENT_STATUS = {
  LEAD: "LEAD",
  OLD_CLIENT: "OLD_CLIENT",
  CLIENT: "CLIENT",
};
export const ATTACHMENT_STATUSES = {
  CRYPTED: "crypted",
  DECRYPTED: "decrypted",
};

export const INITIAL_VALUES = {
  take: 10,
  skip: 0,
};

export const MAX_FEES_VALUE = 50;

export const CONTACT_POINT_SYSTEM = {
  PHONE: "PHONE",
  PHONE_NUMBER_PREFIX: "PHONE_NUMBER_PREFIX",
  LANDLINE: "LANDLINE",
  COMPLEMENT: "COMPLEMENT",
  FAX: "FAX",
  EMAIL: "EMAIL",
  ADDRESS_NUMBER: "ADDRESS_NUMBER",
  REPETITION_INDEX: "REPETITION_INDEX",
  STREET: "STREET",
  APARTMENT: "APARTMENT",
  LOCATION: "LOCATION",
  STREET_TYPE: "STREET_TYPE",
  ZIP_CODE: "ZIP_CODE",
  COUNTRY: "COUNTRY",
  CITY: "CITY",
  BIRTH_CITY: "BIRTH_CITY",
  BIRTH_COUNTRY: "BIRTH_COUNTRY",
  DEPARTMENT_OF_BIRTH: "DEPARTMENT_OF_BIRTH",
  BIRTH_ZIP_CODE: "BIRTH_ZIP_CODE",
  MAILBOX: "MAILBOX",
  POSTAL_ZIP_CODE: "POSTAL_ZIP_CODE",
  POSTAL_CITY: "POSTAL_CITY",
  ADDRESS: "ADDRESS",
  ADDRESS_LOCATION: "ADDRESS_LOCATION",
  ADDRESS_POSTAL: "ADDRESS_POSTAL",
  RESIDENCE: "RESIDENCE",
  ADHERENT_NUMBER: "ADHERENT_NUMBER",
};

export const NAVIGATION_DIRECTIONS = {
  BACK: -1,
};

export const USERS = {
  ADMIN: "ADMIN",
  REGULAR: "REGULAR",
  BENEFICIARY: "BENEFICIARY",
  ADHERENT: "ADHERENT",
  BROKER: "BROKER",
  REPRESENTATIVE: "REPRESENTATIVE",
  COMMERCIAL: "COMMERCIAL",
};

export const TRACER_TYPES = {
  MANUAL: "manual",
  COMPARISON: "comparison",
  COLLECTIVE: "collective",
};

export const INPUT_TYPES = {
  TEXT: "text",
  SELECT: "select",
  DATE: "date",
};

export const QUALIFIER_TYPES = {
  UNTREATED: "UNTREATED",
  ARGUED: "ARGUED",
  NON_ARGUED: "NON_ARGUED",
  WRONG_NUMBER: "WRONG_NUMBER",
  DUPLICATE: "DUPLICATE",
  NO_ANSWER: "NO_ANSWER",
  REFUSAL_ANSWER: "REFUSAL_ANSWER",
  ANSWERING_MACHINE: "ANSWERING_MACHINE",
  QUOTE_SENT: "QUOTE_SENT",
  SIGNED: "SIGNED",
};

export const SOURCE_TYPES = {
  MANUAL: "manual",
};

export const ALL_SOCIAL_REGIMES = {
  SECURITE_SOCIALE: "SECURITE_SOCIALE",
  ALSACE_MOSELLE: "ALSACE_MOSELLE",
  REGIME_SPECIAL: "REGIME_SPECIAL",
  REGIME_SALARIES_AGRICOLES: "REGIME_SALARIES_AGRICOLES",
  SECURITE_SOCIALE_INDEPENDANTS: "SECURITE_SOCIALE_INDEPENDANTS",
  MINIER: "MINIER",
  GRA_SELF_EMPLOYED: "GRA_SELF_EMPLOYED",
  MSA_RL: "MSA_RL",
  SECURITE_SOCIALE_LIBERAL: "SECURITE_SOCIALE_LIBERAL",
  SECURITE_SOCIALE_DOUBLE: "SECURITE_SOCIALE_DOUBLE",
};

export const SOCIAL_REGIMES = {
  SECURITE_SOCIALE: "SECURITE_SOCIALE",
  ALSACE_MOSELLE: "ALSACE_MOSELLE",
  REGIME_SPECIAL: "REGIME_SPECIAL",
  REGIME_SALARIES_AGRICOLES: "REGIME_SALARIES_AGRICOLES",
  SECURITE_SOCIALE_INDEPENDANTS: "SECURITE_SOCIALE_INDEPENDANTS",
};

export const LMF_SOCIAL_REGIMES = {
  SECURITE_SOCIALE: "SECURITE_SOCIALE",
  ALSACE_MOSELLE: "ALSACE_MOSELLE", // Local
  MINIER: "MINIER",
  REGIME_SALARIES_AGRICOLES: "REGIME_SALARIES_AGRICOLES",
  GRA_SELF_EMPLOYED: "GRA_SELF_EMPLOYED", // GRA Professions indépendantes (formerly “Travailleur Non Salarié”)
  // BORDER_WORKERS: "BORDER_WORKERS", // Régime Frontaliers
  // GRA_MINORS_AND_EQUIVALENT: "GRA_MINORS_AND_EQUIVALENT", // GRA Mineurs et assimilés (formerly “Régime Mineurs”)
};

export const MILTIS_SOCIAL_REGIMES = {
  SECURITE_SOCIALE: "SECURITE_SOCIALE",
  SECURITE_SOCIALE_LIBERAL: "SECURITE_SOCIALE_LIBERAL",
  SECURITE_SOCIALE_DOUBLE: "SECURITE_SOCIALE_DOUBLE",
  SECURITE_SOCIALE_INDEPENDANTS: "SECURITE_SOCIALE_INDEPENDANTS",
  REGIME_SALARIES_AGRICOLES: "REGIME_SALARIES_AGRICOLES",
  ALSACE_MOSELLE: "ALSACE_MOSELLE",
};

export const ACORIS_SOCIAL_REGIMES = {
  SECURITE_SOCIALE: "SECURITE_SOCIALE",
  ALSACE_MOSELLE: "ALSACE_MOSELLE",
  MINIER: "MINIER",
  REGIME_SALARIES_AGRICOLES: "REGIME_SALARIES_AGRICOLES",
  SECURITE_SOCIALE_INDEPENDANTS: "SECURITE_SOCIALE_INDEPENDANTS",
  MSA_RL: "MSA_RL",
};

// Statut (JSON parcours: onglet-1 "Statut" — 6 valeurs BA).
export const ACORIS_ACTIVITY_STATUS = {
  SALARIE: "SALARIE",
  INDEPENDANT: "INDEPENDANT",
  RETRAITE: "RETRAITE",
  ETUDIANT: "ETUDIANT",
  SANS_EMPLOI: "SANS_EMPLOI",
  FONCTIONNAIRE: "FONCTIONNAIRE",
};

// Profession (JSON parcours: onglet-1 "Profession" — 15 catégories BA).
export const ACORIS_PROFESSIONS = {
  AGRICULTEURS: "AGRICULTEURS",
  ARTISANS: "ARTISANS",
  COMMERCANTS: "COMMERCANTS",
  PROFESSIONS_LIBERALES: "PROFESSIONS_LIBERALES",
  CHEFS_ENTREPRISE: "CHEFS_ENTREPRISE",
  PROFESSIONNELS_SANTE: "PROFESSIONNELS_SANTE",
  CADRES: "CADRES",
  PROFESSIONS_INTERMEDIAIRES: "PROFESSIONS_INTERMEDIAIRES",
  EMPLOYES: "EMPLOYES",
  OUVRIERS: "OUVRIERS",
  FONCTION_PUBLIQUE: "FONCTION_PUBLIQUE",
  ENSEIGNEMENT_RECHERCHE: "ENSEIGNEMENT_RECHERCHE",
  RETRAITES: "RETRAITES",
  ETUDIANTS: "ETUDIANTS",
  SANS_ACTIVITE: "SANS_ACTIVITE",
};

// Situation familiale (JSON parcours: onglet-1 "Situation familiale" — 6 valeurs).
export const ACORIS_FAMILY_SITUATION = {
  SINGLE: "SINGLE",
  MARRIED: "MARRIED",
  PACS: "PACS",
  COHABITING: "COHABITING",
  DIVORCED: "DIVORCED",
  WIDOWED: "WIDOWED",
};

// Jours de prélèvement (JSON parcours: onglet-1 "Date de prélèvement").
export const ACORIS_DEBIT_DAYS = ["01", "10", "15"];

export const PRICER_KEYS = {
  API: {
    ALPTIS: "api.alptis",
  },
  MOCK: "mock",
  DB: "db",
};

export const PRICER_TYPES = {
  ALPTIS: "api.alptis",
  MOCK: "mock",
  DB: "db",
  COMPOSABLE: "composable",
  COLLECTIVE: "collective",
};

export const PRICING_UNITS = {
  EUR: "eur",
  PMSS: "pmss",
};

export const PRICING_MODES = {
  COMPOSABLE: "COMPOSABLE",
  PACKAGED: "PACKAGED",
};

export const PRICING_AGGREGATORS = {
  SUM: "sum",
};

export const YAML_IMPORT_STRATEGIES = {
  NEW_ONLY: "new_only",
  UPDATE_CORE: "update_core",
};

export const FIELD_IMPORT_SCOPES = {
  SHARED: "shared",
  PROCESS: "process",
};

export const TAG_COLORS = {
  GREEN: "green",
  BLUE: "blue",
  ORANGE: "orange",
  PURPLE: "purple",
  DEFAULT: "default",
};

export const PRICER_AGE_CASES = {
  AGE_ON_EFFECTIVE_DATE: "ageOnEffectiveDate",
  AGE_BY_YEAR: "ageByYear",
  AGE_M_PLUS_1: "ageMPlus1",
  AGE_EFFET_PLUS_12: "ageEffetPlus12",
  AGE_BY_PREVIOUS_YEAR: "ageByPreviousYear",
  AGE_ON_JAN_FIRST: "ageOnJanFirst",
};

export const STATUS = [
  "default",
  "green",
  "danger",
  "warning",
  "info",
  "red",
  "black",
];
export const DEFAULT_STATUS = "default";

export const TYPES = {
  DEFAULT: "default",
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  DANGER: "danger",
};

export const COMPONENTS_SIZES = {
  SMALL: "small",
  LARGE: "large",
  MEDIUM: "medium",
  X_LARGE: "xLarge",
};

export const CASE_TYPES = {
  NEW_CONTRACT: "NEW_CONTRACT",
  RETURN_TO_COMPETITION: "RETURN_TO_COMPETITION",
};

export const SALE_MODES = {
  FACE_TO_FACE: "FACE_TO_FACE",
  DISTANT: "DISTANT",
};

export const COMMERCIALIZATION_TYPES = {
  AGENCY: "Agence",
  REMOTE: "À distance",
  CANVASSING: "Par démarchage",
  OFF_PREMISES: "Hors établissement",
};

export const OPERATION_NATURES = {
  MEMBERSHIP: "MEMBERSHIP",
  MODIFICATION: "MODIFICATION",
  CHANGE_OF_OPTION: "CHANGE_OF_OPTION",
  TERMINATION: "TERMINATION",
};

export const PROJECT_TYPES = {
  HOT_LEAD: "HOT",
  COLD_LEAD: "COLD",
};

export const PROJECT_SOURCE = {
  CLIENT: "CLIENT",
  BROKER: "BROKER",
};

export const PROCESS_TAGS = {
  IN_PROGRESS: "IN_PROGRESS",
  CURRENT_SUBSCRIPTION: "CURRENT_SUBSCRIPTION",
  ELECTRONIC_SIGNATURE_PENDING: "ELECTRONIC_SIGNATURE_PENDING",
  SIGNED: "SIGNED",
  SIGNED_INCOMPLETE: "SIGNED_INCOMPLETE",
  EXPIRED: "EXPIRED",
  QUOTE_SENT: "QUOTE_SENT",
  CLOSE: "CLOSE",
  SENT_TO_MANAGEMENT: "SENT_TO_MANAGEMENT",
};

export const DELTA_END_TYPES = {
  ADD_PERIOD: "ADD_PERIOD",
  END_OF_YEAR: "END_OF_YEAR",
};

export const PERIOD_UNITS = {
  DAYS: "days",
  MONTHS: "months",
  YEARS: "years",
};

export const COMMISSION_TYPES = {
  LINEAR: "LINEAR",
  WITHHOLDING: "WITHHOLDING",
};

export const ACTION_TYPES = {
  NAVIGATE: "NAVIGATE",
  WEBHOOK: "WEBHOOK",
  GENERATE_DOCUMENT: "GENERATE_DOCUMENT",
  DOWNLOAD_DOCUMENTS: "DOWNLOAD_DOCUMENTS",
  SYNC_PROCESSES: "SYNC_PROCESSES",
  NO_SYNC_PROCESSES: "NO_SYNC_PROCESSES",
  SEND_ESIGN_REQUEST: "SEND_ESIGN_REQUEST",
  SEND_SUBSCRIPTION_DOCUMENTS: "SEND_SUBSCRIPTION_DOCUMENTS",
  SEND_ADDITIONAL_DOCUMENTS: "SEND_ADDITIONAL_DOCUMENTS",
  ASSIGN_PROJECT: "ASSIGN_PROJECT",
  NOTIFY_ADVISOR: "NOTIFY_ADVISOR",
  TRACK_CONVERSION: "TRACK_CONVERSION",
  TRACK_SERVER_SIDE_EVENT: "TRACK_SERVER_SIDE_EVENT",
};

export const NODE_TYPES = {
  STATUS: "STATUS",
  FORM_STEP: "FORM_STEP",
  DECISION: "DECISION",
  API_CALL: "API_CALL",
  PRICING: "PRICING",
  GENERATE_DOCUMENTS: "GENERATE_DOCUMENTS",
  SEND_DOCUMENTS: "SEND_DOCUMENTS",
  REQUEST_SIGNATURE: "REQUEST_SIGNATURE",
  AWAIT_SIGNATURE: "AWAIT_SIGNATURE",
  SETUP_PAYMENT: "SETUP_PAYMENT",
  AWAIT_PAYMENT: "AWAIT_PAYMENT",
  PUSH_TO_MANAGEMENT: "PUSH_TO_MANAGEMENT",
  AWAIT_MANAGEMENT_ACK: "AWAIT_MANAGEMENT_ACK",
  REQUEST_TERMINATION: "REQUEST_TERMINATION",
  AWAIT_TERMINATION_ACK: "AWAIT_TERMINATION_ACK",
  COMMISSION: "COMMISSION",
  FORK: "FORK",
  JOIN: "JOIN",
  TIMER: "TIMER",
  NOTIFICATION: "NOTIFICATION",
  ASSIGN: "ASSIGN",
};

export const EDGE_KINDS = {
  CONDITION: "CONDITION",
  EVENT: "EVENT",
  TIMER: "TIMER",
  ALWAYS: "ALWAYS",
};

export const SCREEN_BINDING_KINDS = {
  PROCESS_TRIGGER: "process_trigger",
};

export const PROCESS_TRIGGER_NAMES = {
  NEXT: "next",
  BACK: "back",
};

export const ACTION_STATUSES = {
  IDLE: "idle",
  LOADING: "loading",
  ERROR: "error",
};

export const CONDITION_OPERANDS = {
  TODAY: "today",
};

export const DATA_BINDING_MODES = {
  ONE: "one",
  MANY: "many",
};

export const RUN_STATUSES = {
  RUNNING: "RUNNING",
  AWAITING: "AWAITING",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  CANCELLED: "CANCELLED",
};

export const SCREEN_EVENTS = {
  SOURCE: "kayros-screen",
  TYPES: {
    PAYMENT: "payment",
    RELOAD_STEP: "reload-step",
  },
};

export const STEP_STATUSES = {
  PENDING: "PENDING",
  RUNNING: "RUNNING",
  AWAITING: "AWAITING",
  SUCCEEDED: "SUCCEEDED",
  FAILED: "FAILED",
  SKIPPED: "SKIPPED",
  COMPENSATED: "COMPENSATED",
};

export const FAMILY_SITUATION = {
  MARRIED: "MARRIED",
  DIVORCED: "DIVORCED",
  SEPARATED: "SEPARATED",
  SINGLE: "SINGLE",
  WIDOWED: "WIDOWED",
  PACS: "PACS",
  COHABITING: "COHABITING",
};

export const FAMILY_SITUATIONS = {
  AMELLIS: {
    SINGLE: "SINGLE",
    MARRIED: "MARRIED",
    COHABITING: "COHABITING",
    PACS: "PACS",
  },
  DEFAULT: {
    MARRIED: "MARRIED",
    DIVORCED: "DIVORCED",
    SEPARATED: "SEPARATED",
    SINGLE: "SINGLE",
    WIDOWED: "WIDOWED",
    PACS: "PACS",
    COHABITING: "COHABITING",
  },
};

export const FAMILY_SITUATION_LMF = {
  COUPLE_WITHOUT_CHILDREN: "COUPLE_WITHOUT_CHILDREN",
  COUPLE_WITH_CHILDREN: "COUPLE_WITH_CHILDREN",
  SINGLE_WITHOUT_CHILDREN: "SINGLE_WITHOUT_CHILDREN",
  SINGLE_WITH_CHILDREN: "SINGLE_WITH_CHILDREN",
};

export const PAYMENT_TYPES = {
  DEBIT: "DEBIT",
  DELEGATE: "DELEGATE",
  PUNCTUAL: "PUNCTUAL",
  RECURRENT: "RECURRENT",
  TIP: "TIP",
  CARD: "CARD",
  TRANSFER: "TRANSFER",
  CHECK: "CHECK",
};

export const PAYMENT_FREQUENCIES = {
  MONTHLY: "MONTHLY",
  QUARTERLY: "QUARTERLY",
  BIANNUAL: "BIANNUAL",
  ANNUAL: "ANNUAL",
};

export const PAYMENT_RECEIVER = {
  SAME_ACCOUNT: "SAME_ACCOUNT",
  ANOTHER_ACCOUNT: "ANOTHER_ACCOUNT",
};

export const CONTACT_EXERCISE_FRAME = {
  EMPLOYEE: "EMPLOYEE",
  INDEPENDENT: "INDEPENDENT",
};

export const SOCIO_PROFESSIONAL_CATEGORIES = {
  FARMERS: "FARMERS",
  ARTISANS: "ARTISANS",
  EXECUTIVES: "EXECUTIVES",
  EXECUTIVES_AND_PUBLIC_SERVICE_EMPLOYEES:
    "EXECUTIVES AND PUBLIC SERVICE EMPLOYEES",
  ENTREPRENEURS: "ENTREPRENEURS",
  TRADERS_AND_SIMILAR: "TRADERS AND SIMILAR",
  EMPLOYEES_AND_SUPERVISORS: "EMPLOYEES AND SUPERVISORS",
  WORKERS: "WORKERS",
  PEOPLE_WITHOUT_PROFESSIONAL_ACTIVITY: "PEOPLE WITHOUT PROFESSIONAL ACTIVITY",
  LIBERAL_PROFESSIONS_AND_SIMILAR: "LIBERAL PROFESSIONS AND SIMILAR",
  RETIREES: "RETIREES",
  STUDENT: "STUDENT",
  OTHER: "OTHER",
};

export const MILTIS_CSP_PROFESSIONS = [
  {
    value: SOCIO_PROFESSIONAL_CATEGORIES.FARMERS,
    label: "Agriculteurs exploitants",
    code: "500",
  },
  {
    value: SOCIO_PROFESSIONAL_CATEGORIES.ARTISANS,
    label: "Artisans",
    code: "410",
  },
  {
    value: SOCIO_PROFESSIONAL_CATEGORIES.TRADERS_AND_SIMILAR,
    label: "Commerçants et assimilés",
    code: "430",
  },
  {
    value: SOCIO_PROFESSIONAL_CATEGORIES.ENTREPRENEURS,
    label: "Chefs d'entreprise",
    code: "420",
  },
  {
    value: SOCIO_PROFESSIONAL_CATEGORIES.LIBERAL_PROFESSIONS_AND_SIMILAR,
    label: "Professions libérales et assimilées",
    code: "450",
  },
  {
    value:
      SOCIO_PROFESSIONAL_CATEGORIES.EXECUTIVES_AND_PUBLIC_SERVICE_EMPLOYEES,
    label: "Cadres et employés de la fonction publique",
    code: "280",
  },
  {
    value: SOCIO_PROFESSIONAL_CATEGORIES.EXECUTIVES,
    label: "Cadres d'entreprise",
    code: "220",
  },
  {
    value: SOCIO_PROFESSIONAL_CATEGORIES.EMPLOYEES_AND_SUPERVISORS,
    label: "Employés et agents de maîtrise",
    code: "242",
  },
  {
    value: SOCIO_PROFESSIONAL_CATEGORIES.WORKERS,
    label: "Ouvriers",
    code: "243",
  },
  {
    value: SOCIO_PROFESSIONAL_CATEGORIES.RETIREES,
    label: "Retraités",
    code: "700",
  },
  {
    value: SOCIO_PROFESSIONAL_CATEGORIES.PEOPLE_WITHOUT_PROFESSIONAL_ACTIVITY,
    label: "Personnes sans activité professionnelle",
    code: "290",
  },
];

export const SITUATION_PROFESSIONAL = {
  SALARIED: "SALARIED",
  SALARIED_PRIVATE_SECTOR: "SALARIED_PRIVATE_SECTOR",
  SALARIED_PUBLIC_SECTOR: "SALARIED_PUBLIC_SECTOR",
  SEARCHING_FOR_A_JOB: "SEARCHING_FOR_A_JOB",
  STUDENT: "STUDENT",
  INDEPENDENT: "INDEPENDENT",
  RETIRED: "RETIRED",
};

export const SITUATION_PROFESSIONAL_SALARIED_PRIVATE_SECTOR = {
  EMPLOYEE: "EMPLOYEE",
  WORKER: "WORKER",
  INTERMEDIATE_PROFESSION: "INTERMEDIATE_PROFESSION",
  EXECUTIVE: "EXECUTIVE",
};

export const SITUATION_PROFESSIONAL_SALARIED_PUBLIC_SECTOR = {
  STATE_CIVIL_SERVICE: "STATE_CIVIL_SERVICE",
  TERRITORIAL_CIVIL_SERVICE: "TERRITORIAL_CIVIL_SERVICE",
  HOSPITAL_CIVIL_SERVICE: "HOSPITAL_CIVIL_SERVICE",
};

export const SITUATION_PROFESSIONAL_SEARCHING_FOR_A_JOB = {
  WORKING_STUDENT: "WORKING_STUDENT",
  NON_WORKING_STUDENT: "NON_WORKING_STUDENT",
};

export const SITUATION_PROFESSIONAL_STUDENT = {
  WORKING_STUDENT: "WORKING_STUDENT",
  NON_WORKING_STUDENT: "NON_WORKING_STUDENT",
};

export const SITUATION_PROFESSIONAL_INDEPENDENT = {
  BUSINESS_LEADER: "BUSINESS_LEADER",
  LIBERAL_PROFESSION: "LIBERAL_PROFESSION",
  SELF_EMPLOYED: "SELF_EMPLOYED",
  FARMER: "FARMER",
};

export const SITUATION_PROFESSIONAL_RETIRED = {
  STATE_CIVIL_SERVICE_RETIRED: "STATE_CIVIL_SERVICE_RETIRED",
  TERRITORIAL_CIVIL_SERVICE_RETIRED: "TERRITORIAL_CIVIL_SERVICE_RETIRED",
  HOSPITAL_CIVIL_SERVICE_RETIRED: "HOSPITAL_CIVIL_SERVICE_RETIRED",
  OTHER_RETIRED: "OTHER_RETIRED",
};

export const PROFESSIONAL_SITUATIONS = {
  RETIRED: "RETIRED",
  PRE_RETIRED: "PRE_RETIRED",
  UNEMPLOYED_AFTER_RIGHTS: "UNEMPLOYED_AFTER_RIGHTS",
  SUSPENDED_CONTRACT: "SUSPENDED_CONTRACT",
  DISABILITY_PENSION: "DISABILITY_PENSION",
  DECEASED_EMPLOYEE_DEPENDENTS: "DECEASED_EMPLOYEE_DEPENDENTS",
};

export const REPETITION_INDEX = [
  "A",
  "B (Bis)",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T (Ter)",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];

export const INSURANCE_PLAN_ATTACHMENTS_TYPES = {
  STATUSES: "STATUSES",
  IPID: "IPID",
  INFO_NOTICE: "INFO_NOTICE",
  BROCHURE: "BROCHURE",
  RGPD: "RGPD",
  REIMBURSEMENT_EXAMPLES: "REIMBURSEMENT_EXAMPLES",
  PARTICULAR_PROVISIONS: "PARTICULAR_PROVISIONS",
  REGULATION: "REGULATION",
  INSURANCE_ATTESTATION: "INSURANCE_ATTESTATION",
};

export const SUBSCRIPTION_STATUSES = {
  DRAFT: "DRAFT",
  IN_PROGRESS: "IN_PROGRESS",
  PENDING: "PENDING",
  SIGNED: "SIGNED",
  COMPLETED: "COMPLETED",
};

export const CALL_STATUSES = {
  PENDING: "pending",
  COMPLETED: "completed",
  FAILED: "failed",
};

export const CALL_DIRECTIONS = {
  INBOUND: "inbound",
  OUTBOUND: "outbound",
};

export const ACTIVITY_TYPES = {
  CALL: "call",
  QUALIFICATION: "qualification",
  STATUS: "status",
  EMAIL_SENT: "emailSent",
  WHATSAPP: "whatsapp",
};

export const ACTIVITY_FILTERS = {
  ALL: "ALL",
  CALLS: "CALLS",
  QUALIFICATIONS: "QUALIFICATIONS",
  STATUSES: "STATUSES",
  EMAILS: "EMAILS",
  WHATSAPP: "WHATSAPP",
};

export const ALVIO_ACTIVITY_ACTIONS = {
  SENT: "alvioLeadSent",
  SEND_FAILED: "alvioLeadSendFailed",
  FOLLOW_UP_CANCELLED: "alvioFollowUpCancelled",
  EVENT_RECEIVED: "alvioEventReceived",
};

export const LOGS_STATUSES_KEYS = {
  updateSubscription: "data.result.status",
  addQualification: "data.result.qualifier.name",
  addQuote: "data.result.status",
  sendQuote: "data.result.status",
  generateQuoteDocuments: "data.result.status",
  terminateTask: "data.result.campaignStep.name",
};

export const DEBIT_POSSIBLE_DATES = [
  "5",
  "8",
  "10",
  "12",
  "15",
  "20",
  "25",
  "30",
];

export const LMF_DEBIT_POSSIBLE_DATES = ["5", "10", "20"];

export const JOB_LIST = {
  PROFESSIONAL_ACTIVITY_OTHER_SECTOR: "PROFESSIONAL_ACTIVITY_OTHER_SECTOR",
  PROFESSIONAL_ACTIVITY_PRIVATE_SECTOR: "PROFESSIONAL_ACTIVITY_PRIVATE_SECTOR",
  FARMER: "FARMER",
  ARTISAN: "ARTISAN",
  ENTREPRENEUR: "ENTREPRENEUR",
  TRADER: "TRADER",
  SEARCHING_FOR_A_JOB: "SEARCHING_FOR_A_JOB",
  INDEPENDENT_ENTREPRENEUR: "INDEPENDENT_ENTREPRENEUR",
  STUDENT: "STUDENT",
  POLITICALLY_EXPOSED_ADMINISTRATIVE_FUNCTION:
    "POLITICALLY_EXPOSED_ADMINISTRATIVE_FUNCTION",
  POLITICALLY_EXPOSED_JURISDICTIONAL_FUNCTION:
    "POLITICALLY_EXPOSED_JURISDICTIONAL_FUNCTION",
  POLITICALLY_EXPOSED_MILITARY_FUNCTION:
    "POLITICALLY_EXPOSED_MILITARY_FUNCTION",
  POLITICALLY_EXPOSED_POLITICAL_OR_DIPLOMATIC_FUNCTION:
    "POLITICALLY_EXPOSED_POLITICAL_OR_DIPLOMATIC_FUNCTION",
  STATE_CIVIL_SERVICE: "STATE_CIVIL_SERVICE",
  HOSPITAL_CIVIL_SERVICE: "HOSPITAL_CIVIL_SERVICE",
  TERRITORIAL_CIVIL_SERVICE: "TERRITORIAL_CIVIL_SERVICE",
  AGRICULTURAL_PROFESSION: "AGRICULTURAL_PROFESSION",
  LIBERAL_PROFESSION: "LIBERAL_PROFESSION",
  RETIRED: "RETIRED",
  UNEMPLOYED: "UNEMPLOYED",
  ACTIVE: "ACTIVE",
  HOSPITAL_PRACTITIONER: "HOSPITAL_PRACTITIONER",
};

export const REGEX = {
  EMAIL: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
};

export const DEPARTMENTS = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "2A",
  "2B",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
  "32",
  "33",
  "34",
  "35",
  "36",
  "37",
  "38",
  "39",
  "40",
  "41",
  "42",
  "43",
  "44",
  "45",
  "46",
  "47",
  "48",
  "49",
  "50",
  "51",
  "52",
  "53",
  "54",
  "55",
  "56",
  "57",
  "58",
  "59",
  "60",
  "61",
  "62",
  "63",
  "64",
  "65",
  "66",
  "67",
  "68",
  "69",
  "70",
  "71",
  "72",
  "73",
  "74",
  "75",
  "76",
  "77",
  "78",
  "79",
  "80",
  "81",
  "82",
  "83",
  "84",
  "85",
  "86",
  "87",
  "88",
  "89",
  "90",
  "91",
  "92",
  "93",
  "94",
  "95",
  "97",
  "99",
  "971",
  "972",
  "973",
  "974",
  "975",
  "976",
];

export const CONTENT_TYPES = {
  XLSX: "application/xlsx",
  PDF: "application/pdf",
  JPEG: "image/jpeg",
  JPG: "image/jpg",
  PNG: "image/png",
  CSV: "text/csv",
  SPREADSHEET:
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  XLS: "application/vnd.ms-excel",
};

export const MONTH_OPTIONS = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
];

export const ATTACHMENT_TYPES = {
  PRESCRIPTION: "PRESCRIPTION",
  BILL: "BILL",
  RESULT: "RESULT",
  VIGNETTE: "VIGNETTE",
  TREATMENT_SHEET: "TREATMENT_SHEET",
  REPORT: "REPORT",
  SUPPORT_FORM: "SUPPORT_FORM",
  HONORARY_NOTES: "HONORARY_NOTES",
  OTHER: "OTHER",
  ORGANIZATION_BACKGROUND: "organization.background",
  ORGANIZATION_FAVICON: "organization.favicon",
  PROFILE: "PROFILE",
  SIGNATURE: "SIGNATURE",
  INVOICE: "INVOICE",
  DUTY_OF_ADVICE: "DUTY_OF_ADVICE",
  PAYER_CIN: "PAYER_CIN",
  PAYER_CIN_RECTO: "PAYER_CIN_RECTO",
  PAYER_CIN_VERSO: "PAYER_CIN_VERSO",
  PAYER_RIB: "PAYER_RIB",
  RECEIVER_CIN: "RECEIVER_CIN",
  RECEIVER_CIN_RECTO: "RECEIVER_CIN_RECTO",
  RECEIVER_CIN_VERSO: "RECEIVER_CIN_VERSO",
  CONTRIBUTION_PAYMENT_AGREEMENT: "CONTRIBUTION_PAYMENT_AGREEMENT",
  CIN: "CIN",
  CIN_RECTO: "CIN_RECTO",
  CIN_VERSO: "CIN_VERSO",
  PAYMENT_ACCOUNT: "PAYMENT_ACCOUNT",
  PROFESSIONAL_PAYMENT_ACCOUNT: "PROFESSIONAL_PAYMENT_ACCOUNT",
  STUDENT_ID_OR_ENROLLMENT_CERTIFICATE: "STUDENT_ID_OR_ENROLLMENT_CERTIFICATE",
  HEALTH_INSURANCE_RIGHTS_CERTIFICATE: "HEALTH_INSURANCE_RIGHTS_CERTIFICATE",
  REFUND_ACCOUNT: "REFUND_ACCOUNT",
  SOCIAL_SECURITY_CERTIFICATE: "SOCIAL_SECURITY_CERTIFICATE",
  MARITAL_CERTIFICATE: "MARITAL_CERTIFICATE",
  MEMBERSHIP_FORM: "MEMBERSHIP_FORM",
  IPID: "IPID",
  COVERAGE_GRID: "COVERAGE_GRID",
  KBIS: "KBIS",
  INPI: "INPI",
  INFO_NOTICE: "INFO_NOTICE",
  BROCHURE: "BROCHURE",
  COMMISSION_STATEMENT: "COMMISSION_STATEMENT",
  ICON: "ICON",
  PENSION_FUND: "PENSION_FUND",
  COMMUNITY_ATTACHMENT: "COMMUNITY_ATTACHMENT",
  PAY_SLIP: "PAY_SLIP",
  TAX_NOTICE: "TAX_NOTICE",
  BANK_ACCOUNT_DETAILS_FOR_PAYMENT: "BANK_ACCOUNT_DETAILS_FOR_PAYMENT",
  PROOF_OF_ELIGIBILITY: "PROOF_OF_ELIGIBILITY",
  CHILD_DEPENDENT_PROOF: "CHILD_DEPENDENT_PROOF",
  RGPD: "RGPD",
  SIGNED_DIRECT_MANDATE: "SIGNED_DIRECT_MANDATE",
  ELECTRONIC_SIGNATURE_ELIGIBILITY: "ELECTRONIC_SIGNATURE_ELIGIBILITY",
  PROOF_OF_ADDRESS: "PROOF_OF_ADDRESS",
  REIMBURSEMENT_EXAMPLES: "REIMBURSEMENT_EXAMPLES",
  PARTICULAR_PROVISIONS: "PARTICULAR_PROVISIONS",
  REGULATION: "REGULATION",
  TERRITORIAL_COLLECTIVITY_ATTESTATION: "TERRITORIAL_COLLECTIVITY_ATTESTATION",
  INSURANCE_ATTESTATION: "INSURANCE_ATTESTATION",
  CNRACL_IRCANTEC_AFFILIATION: "CNRACL_IRCANTEC_AFFILIATION",
  EMANCIPATION_CERTIFICATE: "EMANCIPATION_CERTIFICATE",
  LEGAL_REPRESENTATIVE_PROOF: "LEGAL_REPRESENTATIVE_PROOF",
};

export const BANK_ACCOUNT_OWNER_TYPE = {
  PARTICULAR: "PARTICULAR",
  COMPANY: "COMPANY",
};

export const DEFAULT_MILTIS_PHONE_PREFIX = "+33";

export const MILTIS_PHONE_PREFIXES = [
  { value: "+33", label: "+33 — Hexagone" },
  { value: "+596", label: "+596 — Martinique" },
  { value: "+590", label: "+590 — Guadeloupe" },
  { value: "+594", label: "+594 — Guyane" },
  { value: "+262", label: "+262 — Réunion" },
];

export const POLYNESIA_PHONE_PREFIX = "+689";

export const CLIENT_PHONE_PREFIXES = [
  ...MILTIS_PHONE_PREFIXES,
  {
    value: POLYNESIA_PHONE_PREFIX,
    label: "+689 — Polynésie française",
  },
];

export const DEFAULT_ACORIS_PHONE_PREFIX = "+33";

export const ACORIS_PHONE_PREFIXES = [
  { value: "+33", label: "+33 — Hexagone" },
  { value: "+596", label: "+596 — Martinique" },
  { value: "+590", label: "+590 — Guadeloupe" },
  { value: "+594", label: "+594 — Guyane" },
];

export const REGEX_EXPS = {
  zipCode: /^(0[1-9]|[1-8][0-9]|9[0-8])[0-9]{3}$/,
  mobilePhone: /^(06|07)[0-9]{8}$/,
  phone: /^(0)[0-9]{9}$/,
  onlyTenDigits: /^\d{10}$/,
  onlyNumbers: /^[0][0-9]{9}$/,
  // internationalMobilePhone: /^\+\d{2}\d{9}$|^0\d{9}$/,
  internationalMobilePhone: /^(?:\+?\d{1,3}|00\d{1,3})?\s?\d{9}$/,
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{12,}$/,
  imei: /^\d{15,17}$/,
  vini: /^\d{10}$/,
  phonePolynisie: /^(87|88|89)\d{6}$/,
  franceIban: /^(FR|CZ|NL)\d{2}20041010050500013[A-Z0-9]{6}$/,
  name: /^[A-Za-zÀ-ÖØ-öø-ÿ][A-Za-zÀ-ÖØ-öø-ÿ' -]{0,}[A-Za-zÀ-ÖØ-öø-ÿ]$/,
  mailbox: /^(BP|bp)\d+|\d{7}$/,
  address: /^(?=.*[A-Za-z])[A-Za-zÀ-ÖØ-öø-ÿ0-9\s',.-]{4,}$/,
  cityName: /^[A-Za-zÀ-ÿ\s'-]+$/,
  contractNumber: /^[A-Za-z0-9-]+$/,
  referralCode: /^[A-Z0-9]{6}$/,
};

export const BENEFICIARY_TYPES = {
  ADHERENT: "ADHERENT",
  SPOUSE: "SPOUSE",
  CHILD: "CHILD",
};

export const PRICER_STRUCTURES = {
  INDIVIDUAL: "individual",
  ISOLATED_DUO_FAMILY: "isolated_duo_family",
};

export const PRICER_STRUCTURE_TYPOLOGIES = {
  SINGLE: "single",
  DUO: "duo",
  FAMILY: "family",
};

export const INCLUDED_BENEFICIARIES = {
  ALONE: "ALONE",
  WITH_SPOUSE: "WITH_SPOUSE",
  WITH_CHILDREN: "WITH_CHILDREN",
  ALL: "ALL",
};

export const DOCUMENTS_TYPES = {
  DUTY_OF_ADVICE: "DUTY_OF_ADVICE",
  DUTY_OF_ADVICE_QUOTE: "DUTY_OF_ADVICE_QUOTE",
  QUOTE: "QUOTE",
  MEMBERSHIP_FORM: "MEMBERSHIP_FORM",
  SEPA_DIRECT_DEBIT_MANDATE: "SEPA_DIRECT_DEBIT_MANDATE",
  SUPPLEMENTARY_DOCUMENTS: "SUPPLEMENTARY_DOCUMENTS",
  TERMINATION_LETTER: "TERMINATION_LETTER",
  TERMINATION_MANDATE: "TERMINATION_MANDATE",
  PROPOSAL: "PROPOSAL",
  SPECIAL_CONDITIONS: "SPECIAL_CONDITIONS",
  COLLECTION_SCHEDULE: "COLLECTION_SCHEDULE",
  DIRECT_DEBIT_AUTHORIZATION: "DIRECT_DEBIT_AUTHORIZATION",
  CIN: "CIN",
  SIGNED_DIRECT_MANDATE: "SIGNED_DIRECT_MANDATE",
  PAYER_CIN: "PAYER_CIN",
  PAYER_RIB: "PAYER_RIB",
  RECEIVER_CIN: "RECEIVER_CIN",
  CONTRIBUTION_PAYMENT_AGREEMENT: "CONTRIBUTION_PAYMENT_AGREEMENT",
  PAYMENT_ACCOUNT: "PAYMENT_ACCOUNT",
  PROFESSIONAL_PAYMENT_ACCOUNT: "PROFESSIONAL_PAYMENT_ACCOUNT",
  STUDENT_ID_OR_ENROLLMENT_CERTIFICATE: "STUDENT_ID_OR_ENROLLMENT_CERTIFICATE",
  REFUND_ACCOUNT: "REFUND_ACCOUNT",
  SOCIAL_SECURITY_CERTIFICATE: "SOCIAL_SECURITY_CERTIFICATE",
  MARITAL_CERTIFICATE: "MARITAL_CERTIFICATE",
  KBIS: "KBIS",
  INPI: "INPI",
  UNKNOWN: "UNKNOWN",
  STATIC_INSURANCE_PLAN: "STATIC_INSURANCE_PLAN",
  PENSION_FUND: "PENSION_FUND",
  COMMUNITY_ATTACHMENT: "COMMUNITY_ATTACHMENT",
  PAY_SLIP: "PAY_SLIP",
  TAX_NOTICE: "TAX_NOTICE",
  BANK_ACCOUNT_DETAILS_FOR_PAYMENT: "BANK_ACCOUNT_DETAILS_FOR_PAYMENT",
  PROOF_OF_ELIGIBILITY: "PROOF_OF_ELIGIBILITY",
  CHILD_DEPENDENT_PROOF: "CHILD_DEPENDENT_PROOF",
  ELECTRONIC_SIGNATURE_ELIGIBILITY: "ELECTRONIC_SIGNATURE_ELIGIBILITY",
  PROOF_OF_ADDRESS: "PROOF_OF_ADDRESS",
  CONSENT_FORM: "CONSENT_FORM",
};

export const INSURANCE_PLAN_PARAMS_RULES = {
  MIN_AGE: "MIN_AGE",
  MAX_AGE: "MAX_AGE",
  DELTA_START: "DELTA_START",
  DELTA_END: "DELTA_END",
  DELTA_START_RIA: "DELTA_START_RIA",
  DELTA_END_RIA: "DELTA_END_RIA",
  EXERCISE_FRAME: "EXERCISE_FRAME",
  SOCIAL_REGIMES: "SOCIAL_REGIMES",
  DEPARTMENTS: "DEPARTMENTS",
  IDCC: "IDCC",
  ZIP_CODES: "ZIP_CODES",
  MUNICIPALITIES: "MUNICIPALITIES",
  PROCESSES: "PROCESSES",
  DOCUMENTS: "DOCUMENTS",
  GENERATED_DOCUMENTS: "GENERATED_DOCUMENTS",
  DOCUMENT_STEPS: "DOCUMENT_STEPS",
  PROFESSION: "PROFESSION",
  PROFILES: "PROFILES",
  SUB_PROFILES: "SUB_PROFILES",
  IS_PHONE_SIM_OR_ESIM: "IS_PHONE_SIM_OR_ESIM",
  IS_PHONE_NEW_OR_GRADE_A: "IS_PHONE_NEW_OR_GRADE_A",
  IS_PHONE_PURCHASED_INTERNALLY: "IS_PHONE_PURCHASED_INTERNALLY",
  IS_PHONE_UNDER_THREE_YEARS: "IS_PHONE_UNDER_THREE_YEARS",
  IS_PHONE_FOR_PRIVATE_USE: "IS_PHONE_FOR_PRIVATE_USE",
  IS_CUSTOMER_IN_FRENCH_POLYNESIA: "IS_CUSTOMER_IN_FRENCH_POLYNESIA",
  RETROACTIVITY_ENABLED: "RETROACTIVITY_ENABLED",
  RETROACTIVITY_DAYS: "RETROACTIVITY_DAYS",
  QUOTE_VALIDITY: "QUOTE_VALIDITY",
};

export const DOCUMENT_KINDS = {
  DYNAMIC: "DYNAMIC",
  STATIC: "STATIC",
};

export const DOCUMENT_STEPS = {
  DEVIS: "DEVIS",
  CONTRAT: "CONTRAT",
  SIGNATURE: "SIGNATURE",
};

export const DOCUMENTS_GENERATION_MODES = {
  E_SIGNATURE: "E_SIGNATURE",
  EMAIL: "EMAIL",
  DOWNLOAD: "DOWNLOAD",
};

export const MODAL_STATES = {
  INITIAL: "INITIAL",
  PENDING: "PENDING",
  DONE: "DONE",
};

export const FRANCE_DEPARTMENTS = [
  { code: "01", name: "Ain" },
  { code: "02", name: "Aisne" },
  { code: "03", name: "Allier" },
  { code: "04", name: "Alpes-de-Haute-Provence" },
  { code: "05", name: "Hautes-Alpes" },
  { code: "06", name: "Alpes-Maritimes" },
  { code: "07", name: "Ardèche" },
  { code: "08", name: "Ardennes" },
  { code: "09", name: "Ariège" },
  { code: "10", name: "Aube" },
  { code: "11", name: "Aude" },
  { code: "12", name: "Aveyron" },
  { code: "13", name: "Bouches-du-Rhône" },
  { code: "14", name: "Calvados" },
  { code: "15", name: "Cantal" },
  { code: "16", name: "Charente" },
  { code: "17", name: "Charente-Maritime" },
  { code: "18", name: "Cher" },
  { code: "19", name: "Corrèze" },
  { code: "2A", name: "Corse-du-Sud" },
  { code: "2B", name: "Haute-Corse" },
  { code: "21", name: "Côte-d'Or" },
  { code: "22", name: "Côtes-d'Armor" },
  { code: "23", name: "Creuse" },
  { code: "24", name: "Dordogne" },
  { code: "25", name: "Doubs" },
  { code: "26", name: "Drôme" },
  { code: "27", name: "Eure" },
  { code: "28", name: "Eure-et-Loir" },
  { code: "29", name: "Finistère" },
  { code: "30", name: "Gard" },
  { code: "31", name: "Haute-Garonne" },
  { code: "32", name: "Gers" },
  { code: "33", name: "Gironde" },
  { code: "34", name: "Hérault" },
  { code: "35", name: "Ille-et-Vilaine" },
  { code: "36", name: "Indre" },
  { code: "37", name: "Indre-et-Loire" },
  { code: "38", name: "Isère" },
  { code: "39", name: "Jura" },
  { code: "40", name: "Landes" },
  { code: "41", name: "Loir-et-Cher" },
  { code: "42", name: "Loire" },
  { code: "43", name: "Haute-Loire" },
  { code: "44", name: "Loire-Atlantique" },
  { code: "45", name: "Loiret" },
  { code: "46", name: "Lot" },
  { code: "47", name: "Lot-et-Garonne" },
  { code: "48", name: "Lozère" },
  { code: "49", name: "Maine-et-Loire" },
  { code: "50", name: "Manche" },
  { code: "51", name: "Marne" },
  { code: "52", name: "Haute-Marne" },
  { code: "53", name: "Mayenne" },
  { code: "54", name: "Meurthe-et-Moselle" },
  { code: "55", name: "Meuse" },
  { code: "56", name: "Morbihan" },
  { code: "57", name: "Moselle" },
  { code: "58", name: "Nièvre" },
  { code: "59", name: "Nord" },
  { code: "60", name: "Oise" },
  { code: "61", name: "Orne" },
  { code: "62", name: "Pas-de-Calais" },
  { code: "63", name: "Puy-de-Dôme" },
  { code: "64", name: "Pyrénées-Atlantiques" },
  { code: "65", name: "Hautes-Pyrénées" },
  { code: "66", name: "Pyrénées-Orientales" },
  { code: "67", name: "Bas-Rhin" },
  { code: "68", name: "Haut-Rhin" },
  { code: "69", name: "Rhône" },
  { code: "70", name: "Haute-Saône" },
  { code: "71", name: "Saône-et-Loire" },
  { code: "72", name: "Sarthe" },
  { code: "73", name: "Savoie" },
  { code: "74", name: "Haute-Savoie" },
  { code: "75", name: "Paris" },
  { code: "76", name: "Seine-Maritime" },
  { code: "77", name: "Seine-et-Marne" },
  { code: "78", name: "Yvelines" },
  { code: "79", name: "Deux-Sèvres" },
  { code: "80", name: "Somme" },
  { code: "81", name: "Tarn" },
  { code: "82", name: "Tarn-et-Garonne" },
  { code: "83", name: "Var" },
  { code: "84", name: "Vaucluse" },
  { code: "85", name: "Vendée" },
  { code: "86", name: "Vienne" },
  { code: "87", name: "Haute-Vienne" },
  { code: "88", name: "Vosges" },
  { code: "89", name: "Yonne" },
  { code: "90", name: "Territoire de Belfort" },
  { code: "91", name: "Essonne" },
  { code: "92", name: "Hauts-de-Seine" },
  { code: "93", name: "Seine-Saint-Denis" },
  { code: "94", name: "Val-de-Marne" },
  { code: "95", name: "Val-d'Oise" },
  { code: "99", name: "Autre/Etranger" },
  { code: "971", name: "Guadeloupe" },
  { code: "972", name: "Martinique" },
  { code: "973", name: "Guyane" },
  { code: "974", name: "La Réunion" },
  { code: "975", name: "Saint-Pierre-et-Miquelon" },
  { code: "976", name: "Mayotte" },
];

/** Select options for department attribution skills (all orgs). */
export const getDepartmentSkillOptions = () => {
  const namesByCode = FRANCE_DEPARTMENTS.reduce(
    (acc, { code, name }) => ({ ...acc, [code]: name }),
    {},
  );
  return DEPARTMENTS.map((code) => ({
    value: code,
    label: namesByCode[code] ? `${code} - ${namesByCode[code]}` : code,
  }));
};

export const GENERATED_DOCUMENTS_TYPES = [
  "QUOTE",
  "DUTY_OF_ADVICE_QUOTE",
  "DUTY_OF_ADVICE",
  "MEMBERSHIP_FORM",
  "SEPA_DIRECT_DEBIT_MANDATE",
  "TERMINATION_LETTER",
  "TERMINATION_MANDATE",
];

export const DOCUMENT_TEMPLATE_AREAS = {
  QUOTE: "QUOTE",
  SUBSCRIPTION: "SUBSCRIPTION",
};

export const DOCUMENT_TEMPLATE_STATUSES = {
  DRAFT: "draft",
};

export const DOCUMENT_TEMPLATE_STATES = {
  DRAFT: "draft",
  PUBLISHED: "published",
  CHANGED: "changed",
};

export const DOCUMENT_TEMPLATE_MOMENTS = {
  QUOTE: "QUOTE",
  SUBSCRIPTION: "SUBSCRIPTION",
  BOTH: "BOTH",
};

export const GENERATED_DOCUMENTS_VERSIONS = {
  QUOTE: [
    "DEFAULT",
    "COSA_TER",
    "MUTUELLE_AURA",
    "AURA_TERR",
    "PREMEO",
    "LUMINEIS",
    "OBSEQUE",
  ],
  DUTY_OF_ADVICE: [
    "DEFAULT",
    "COSA_TER",
    "MUTUELLE_AURA",
    "AURA_TERR",
    "LUMINEIS",
    "OBSEQUE",
  ],
  DUTY_OF_ADVICE_QUOTE: [
    "DEFAULT",
    "COSA_TER",
    "MUTUELLE_AURA",
    "AURA_TERR",
    "LUMINEIS",
    "OBSEQUE",
  ],
  MEMBERSHIP_FORM: [
    "DEFAULT",
    "COSA_TER",
    "MUTUELLE_AURA",
    "AURA_TERR",
    "COLLECTIVE",
    "COLLECTIVE_WITHOUT_SIGNATURE",
    "LUMINEIS",

    "PREMEO",

    "BA_SAL_SIG_UNI",
    "BA_SAL_SIG_MOD",
    "BA_SAL_VAL_UNI",
    "BA_SAL_VAL_MOD",
    "BA_AGT_SIG_UNI",
    "BA_AGT_SIG_MOD",
    "BA_AGT_VAL_UNI",
    "BA_AGT_VAL_MOD",

    "BAI_LMF_SANTE_OK",
    "BIA_CONFORT_TNS",
    "BIA_IDF_MUTUELLE_SANTE_TNS",
    "BAI_LMF_TERRI_OK",
    "BIA_MDC_Standard",
    "BIA_MDC_SPE",
    "BIA_ASSOCIATION",
    "BIA_CONFORT_OK",
    "BIA_IDF_MUTUELLE_SANTE_OK",
    "BIA_LMF_SANTE_TNS_OK",
    "BIA_BASE_MANDAT",
    "BIA_CONFORT_MANDAT",
    "BIA_MOBILITY_HEALTH",
    "BIA_LIBERTE_MANDAT",
    "BIA_SERENITE_MANDAT",
    "BIA_VITALITE_MANDAT",
    "BIA_TNS_MANDAT",
    "OBSEQUE",
  ],
  SEPA_DIRECT_DEBIT_MANDATE: [
    "DEFAULT",
    "COSA_TER",
    "MUTUELLE_AURA",
    "LUMINEIS",
    "OBSEQUE",
  ],
  TERMINATION_LETTER: [
    "DEFAULT",
    "COSA_TER",
    "MUTUELLE_AURA",
    "LUMINEIS",
    "OBSEQUE",
  ],
  TERMINATION_MANDATE: [
    "DEFAULT",
    "COSA_TER",
    "MUTUELLE_AURA",
    "LUMINEIS",
    "OBSEQUE",
  ],
  APPENDIX_MEMBERSHIP_FORM: [
    "AFFILIATION",
    "AFFILIATION_RENFORTS",
    "INDIVIDUELLE",
    "INDIVIDUELLE_RENFORTS",
  ],
  undefined: [],
};

export const TRACER_FILTER = {
  AURA: "Mutuelle Aura",
  COSAE_TER: "Cosae Ter",
};

export const THEMES_PALETTE = {
  [TEMPLATE_TYPES.DEFAULT]: {
    COLOR: "#0E93E5",
    BACKGROUND: "#DDF2FE",
    NAME: "Aura",
    PROSPECT_PROCESS: TEMPLATE_TYPES.RADIANCE,
    TITLE: "Espace Conseiller",
  },
  [TEMPLATE_TYPES.B2B_RADIANCE_COSA]: {
    COLOR: "#BD0027",
    BACKGROUND: "#FFE1E7",
    NAME: "Cosae Ter",
    PROSPECT_PROCESS: TEMPLATE_TYPES.RADIANCE_COSA,
    TITLE: "Espace Conseiller",
  },
  [TEMPLATE_TYPES.B2B_RADIANCE_AURA_TER]: {
    COLOR: "#BD0027",
    BACKGROUND: "#FFE1E7",
    NAME: "Aura Ter",
    PROSPECT_PROCESS: TEMPLATE_TYPES.RADIANCE_AURA_TER,
    TITLE: "Espace Conseiller",
  },
  [TEMPLATE_TYPES.B2B_SMART_PHONE]: {
    COLOR: "#BD0027",
    BACKGROUND: "#FFE1E7",
    // NAME: "Smart Phone",
    PROSPECT_PROCESS: "",
    TITLE: "Espace Conseiller",
  },
  [TEMPLATE_TYPES.RADIANCE]: {
    COLOR: "#0E93E5",
    BACKGROUND: "#DDF2FE",
    NAME: "Aura",
    PROSPECT_PROCESS: TEMPLATE_TYPES.RADIANCE,
    TITLE: "Devis Mutuelle Régionale",
  },
  [TEMPLATE_TYPES.RADIANCE_COSA]: {
    COLOR: "#BD0027",
    BACKGROUND: "#FFE1E7",
    NAME: "Cosae Ter",
    PROSPECT_PROCESS: TEMPLATE_TYPES.RADIANCE_COSA,
    TITLE: "Devis Cosae Ter",
  },
  [TEMPLATE_TYPES.RADIANCE_AURA_TER]: {
    COLOR: "#BD0027",
    BACKGROUND: "#FFE1E7",
    NAME: "Aura Ter",
    PROSPECT_PROCESS: TEMPLATE_TYPES.RADIANCE_AURA_TER,
    TITLE: "Devis Aura Ter",
  },
  [TEMPLATE_TYPES.B2B_MILTIS]: {
    COLOR: "#0E93E5",
    BACKGROUND: "#DDF2FE",
    NAME: "AURA/Lumineis",
    PROSPECT_PROCESS: TEMPLATE_TYPES.B2C_MILTIS,
    TITLE: "Espace Conseiller",
  },
  [TEMPLATE_TYPES.B2B_MILTIS_TER]: {
    COLOR: "#0E93E5",
    BACKGROUND: "#DDF2FE",
    NAME: "AURA TER",
    PROSPECT_PROCESS: TEMPLATE_TYPES.B2C_MILTIS_TER,
    TITLE: "Espace Conseiller",
  },
  [TEMPLATE_TYPES.B2C_MILTIS]: {
    PROSPECT_PROCESS: TEMPLATE_TYPES.B2C_MILTIS,
    TITLE: "Votre devis Mutuelle Régionale",
    NAME: "AURA/Lumineis",
  },
  [TEMPLATE_TYPES.B2C_MILTIS_TER]: {
    PROSPECT_PROCESS: TEMPLATE_TYPES.B2C_MILTIS_TER,
    TITLE: "Votre devis Mutuelle Régionale Agents Territoriaux",
    NAME: "AURA TER",
  },
  [TEMPLATE_TYPES.B2C_ACORIS]: {
    COLOR: "#119ED9",
    BACKGROUND: "#B3E6FB",
    PROSPECT_PROCESS: TEMPLATE_TYPES.B2C_ACORIS,
    TITLE: "Votre devis ACORIS Mutuelles",
    NAME: "ACORIS Mutuelles",
  },
  [TEMPLATE_TYPES.B2B_ACORIS]: {
    COLOR: "#119ED9",
    BACKGROUND: "#B3E6FB",
    PROSPECT_PROCESS: TEMPLATE_TYPES.B2C_ACORIS,
    TITLE: "Espace Conseiller",
    NAME: "ACORIS Mutuelles",
  },
  [TEMPLATE_TYPES.B2B_ACORIS_COLLECTIVE]: {
    COLOR: "#119ED9",
    BACKGROUND: "#B3E6FB",
    TITLE: "Espace Conseiller — Santé collective ACORIS",
    NAME: "ACORIS Mutuelles",
  },
  [TEMPLATE_TYPES.B2B_SOLYON]: {
    PROSPECT_PROCESS: TEMPLATE_TYPES.B2C_SOLYON,
    TITLE: "Espace Conseiller",
  },
  [TEMPLATE_TYPES.B2B_SNCA]: {
    TITLE: "Devis SNCA",
    NAME: "SNCA",
  },
  [TEMPLATE_TYPES.B2B_LAFOURGALE]: {
    TITLE: "Kayros Téléconsultation La Fourgale",
    NAME: "La Fourgale",
  },
  [TEMPLATE_TYPES.B2B_DYNAMIC]: {
    COLOR: "#0E93E5",
    BACKGROUND: "#DDF2FE",
    NAME: "",
    PROSPECT_PROCESS: TEMPLATE_TYPES.B2C_MILTIS,
    TITLE: "Espace Conseiller — parcours dynamique",
  },
  [TEMPLATE_TYPES.B2C_SOLYON]: {
    PROSPECT_PROCESS: TEMPLATE_TYPES.B2C_SOLYON,
    TITLE: "Devis So'Lyon",
  },
  [TEMPLATE_TYPES.B2C_AMELLIS]: {
    PROSPECT_PROCESS: TEMPLATE_TYPES.B2C_AMELLIS,
    TITLE: "Devis Amellis",
  },
  [TEMPLATE_TYPES.B2B_AMELLIS]: {
    PROSPECT_PROCESS: TEMPLATE_TYPES.B2C_AMELLIS,
    TITLE: "Espace Conseiller",
  },
  [TEMPLATE_TYPES.B2B_LMF]: {
    // PROSPECT_PROCESS: TEMPLATE_TYPES.B2C_LMF,
    TITLE: "Espace Conseiller",
  },
  [TEMPLATE_TYPES.B2C_LMF]: {
    // PROSPECT_PROCESS: TEMPLATE_TYPES.B2C_LMF,
    TITLE: "Devis LMF",
  },
  [TEMPLATE_TYPES.B2B_MUTUAL_MOBILITY]: {
    PROSPECT_PROCESS: TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY,
    TITLE: "Espace Conseiller",
  },
  [TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY]: {
    PROSPECT_PROCESS: TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY,
    TITLE: "Devis Mobilité mutuelle",
  },
};

export const STATUS_USERS = {
  AVAILABLE: "AVAILABLE",
  NOT_RESPONDING: "NOT_RESPONDING",
  AWAY: "AWAY",
  BUSY: "BUSY",
};

export const STATUS_PUBLICATION = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  DRAFT: "DRAFT",
  RETIRED: "RETIRED",
};

export const INSURANCE_PLAN_RISKS = {
  HEALTH: "health",
  TERMINAL: "terminal",
  PRO: "pro",
  PROVIDENT: "provident",
  SERVICE: "service",
  SPORTS_LEISURE: "sports_leisure",
  OBSEQUE: "obseque",
};

export const SUBSCRIPTION_TEMPLATES = {
  MCCI: "MCCI",
  MILTIS: "Miltis",
  SMART_PHONE: "SmartPhone",
  HEALTH: "Health",
  SOLYON_HEALTH: "SoLyonHealth",
  LMF_HEALTH: "LmfHealth",
  AMELLIS_HEALTH: "AmellisHealth",
  MUTUAL_MOBILITY_HEALTH: "MutualMobility",
  SNCA: "SNCA",
  LAFOURGALE: "Lafourgale",
  ACORIS: "Acoris",
};

export const DEVICES_API =
  "https://script.google.com/macros/s/AKfycbxNu27V2Y2LuKUIQMK8lX1y0joB6YmG6hUwB1fNeVbgzEh22TcDGrOak03Fk3uBHmz-/exec?route=device-list";

export const ACTIVITY_TIME_OPTIONS = [50, 60, 70, 75, 80, 90, 100];

export const INCOME_TYPES = {
  MONTHLY: "MONTHLY",
  ANNUAL: "ANNUAL",
};

export const INPUT_TYPES_FULL = {
  TEXT: "text",
  EMAIL: "email",
  PASSWORD: "password",
  PHONE: "phone",
  NUMBER: "number",
  TEXTAREA: "textarea",
  CHECKBOX: "checkbox",
  SWITCH: "switch",
  COLOR: {
    SIMPLE: "color-simple",
    PICKER: "color-picker",
  },
  DATE: {
    RANGE: "date-range",
    SIMPLE: "date-simple",
  },
  RADIO: {
    SIMPLE: "radio-simple",
    GROUP: "radio-group",
  },
  SELECT: {
    NORMAL: "simple",
    // ASYNC: "async",
    // TAG: "tag",
    // SUBTEXT: "subtext",
  },
  // FILE: {
  //   SINGLE: "single-file",
  //   MULTIPLE: "multiple-file",
  // },

  // SLIDER: {
  //   SINGLE: "slider-single",
  //   RANGE: "slider-range",
  // },
  // AUTOCOMPLETE: {
  //   NORMAL: "autocomplete-normal",
  //   ASYNC: "autocomplete-async",
  // },
};

export const SKILL_TYPES = {
  ZIPCODE: "zipCode",
  ESTABLISHMENT: "establishment",
  AGENCY: "agency",
  STORE: "store",
  DEPARTMENT: "department",
  PROCESS: "process",
};

export const MEMBERSHIP_ORIGINS = {
  DISPLAY: "Affichage",
  PRESS_ARTICLE: "Article dans la presse",
  WORD_OF_MOUTH: "Bouche à oreille",
  ALREADY_MEMBER: "Déjà adhérent",
  HOSPITALS: "Hôpitaux",
  ONLINE_ADVERTISING: "Publicité sur internet",
  RADIO: "Radio",
  INTERNET_SEARCH: "Recherche sur internet",
  SOCIAL_NETWORKS: "Réseaux sociaux",
  PARTNER: "Via un de nos partenaires",
  OTHER: "Autre",
};

export const ESTABLISHMENTS = [
  "Blanchisserie centrale (HCL)",
  "Centre de soins dentaire (HCL)",
  "CH Lyon Sud (HCL)",
  "Direction des affaires domaniales (HCL)",
  "Direction du personnel et des affaires sociales (HCL)",
  "Hôpital Louis Pradel (HCL)",
  "Hôpital de la Croix Rousse (HCL)",
  "Hôpital des Charpennes (HCL)",
  "Hôpital Edouard Herriot (HCL)",
  "Hôpital Femme Mère Enfant (HCL)",
  "Hôpital Geriatrique Dugoujon (HCL)",
  "Hôpital Geriatrique Pierre Garraud (HCL)",
  "Hôpital Henry Gabrielle (HCL)",
  "Hôpital neurologique Pierre Wertheimer (HCL)",
  "Hôpital Renée Sabran (HCL)",
  "Institut d'Hematologie et Oncologie Pédiatrique (HCL)",
  "Siège Administratif (HCL)",
  "Stérilisation (HCL)",
  "UCPA cuisine centrale (HCL)",
  "CH Gériatrique du Mont d'Or",
  "CH Le Vinatier",
  "CH Lucien Hussel",
  "CH Luzy-Dufeillant",
  "CH Montgelas",
  "CH Saint Cyr au Mont d'Or",
  "CH Tarare",
  "CH Villefranche",
  "Hôpital de Beaujeu",
  "Hôpital de Belleville",
  "Hôpital de Condrieu",
  "Hôpital de Pelussin",
  "Hôpital de Sainte-Foy-Lès-Lyon",
  "Hôpital Gériatrique du Val d'Azergues",
  "Hôpital Montpensier",
  "Hôpital Rural de Neuville sur Saône",
  "Autres établissements",
];

export const ATTRIBUTION_TYPE = {
  ROUND_ROBIN: "ROUND_ROBIN",
  FIRST_PICK: "FIRST_PICK",
};

export const PROCESS_CONFIG_TYPES = {
  NEEDS: "NEEDS",
  EMAIL: "EMAIL",
  ATTRIBUTION_TYPE: "ATTRIBUTION_TYPE",
  PRODUCT: "PRODUCT",
  PREVIOUS_ADVISOR_CONFIG: "PREVIOUS_ADVISOR_CONFIG",
  ASSOCIATED_PROCESSES: "ASSOCIATED_PROCESSES",
};

export const MATCHING_FIELDS = {
  EMAIL: "email",
  PHONE: "phone",
  ADHERENT_INFO: "adherentInfo",
};
export const SUBSCRIBER_TYPES = {
  ADHERENT: "ADHERENT",
  OTHER: "OTHER",
};

export const BIRTH_COUNTRY_PARAMS = {
  FRANCE: "FRANCE",
  POLYNESIE_FRANCAISE: "POLYNESIE_FRANCAISE",
  OTHER: "OTHER",
};

export const ACTIVITY_STATUS = {
  ACTIVE: "En activité",
  SELF_EMPLOYED: "Libéral",
  STUDENT: "Étudiant",
  NON_SALARIED: "Travailleur Non Salarié",
  INACTIVE: "Sans activité",
};

export const QUALIFIER_TAGS = {
  CALL_LATER: "CALL_LATER",
  PURSUIT_RADIANCE: "PURSUIT_RADIANCE",
  OLD_CONTRACT: "OLD_CONTRACT",
  NO_TERMINATION: "NO_TERMINATION",
  HOT_LIST_EXIT: "HOT_LIST_EXIT",
};

export const LMF_ASSOCIATION_MEMBER_TYPE = {
  FRS_FEDERATION: "FRS_FEDERATION",
  CFDT_UNION_BAS_RHIN: "CFDT_UNION_BAS_RHIN",
  LSR_FEDERATION: "LSR_FEDERATION",
  MCCORMICK_ALUMNI_ASSOCIATION: "MCCORMICK_ALUMNI_ASSOCIATION",
  EPRO_SOLIDAIRES_EURODIF_RETIREES: "EPRO_SOLIDAIRES_EURODIF_RETIREES",
  CGT_RETIRED_CHAFFOTEAUX_MAURY: "CGT_RETIRED_CHAFFOTEAUX_MAURY",
  CFDT_UNION_HAUT_RHIN: "CFDT_UNION_HAUT_RHIN",
  ORANOR_AREVA_RETIREES: "ORANOR_AREVA_RETIREES",
  CGT_RETIREES: "CGT_RETIREES",
  RETIREMENT_SPORTS: "RETIREMENT_SPORTS",
  RETIREMENT_SOLIDARITY_LEISURE: "RETIREMENT_SOLIDARITY_LEISURE",
};

export const LMF_ORIGINS = {
  MARKETING_CAMPAIGN: "Marketing Campaign",
  COMMUNICATION_CAMPAIGN: "Communication Campaign",
  WEB_ESTIMATOR: "Web Estimator",
  LANDING_PAGE_CONVERSION: "Landing Page Conversion %",
  REFERRAL: "Referral",
};

export const LMF_CONTACT_CANAL = {
  AGENCY: "Agency",
  OUTREACH_OFFICE: "Outreach Office",
  INCOMING_CALL: "Incoming Call",
  OUTGOING_CALL: "Outgoing Call",
  EMAIL: "Email",
  POSTAL_MAIL: "Postal Mail",
};

export const COMMUNICATION_CAMPAIGN_MEDIA = {
  TV: "Television",
  BILLBOARD: "Billboard",
  RADIO: "Radio",
  PRESS: "Press",
};

export const PROFILE_LIST = {
  RETIRED: "RETIRED",
  STUDENT: "STUDENT",
  UNEMPLOYED: "UNEMPLOYED",
  TEMPORARY_WORKER: "TEMPORARY_WORKER",
  EMPLOYEE: "EMPLOYEE",
  CROSS_BORDER_WORKER: "CROSS_BORDER_WORKER",
  TNS: "TNS",
  LIBERAL_PROFESSION: "LIBERAL_PROFESSION",
  MICRO_ENTERPRISE: "MICRO_ENTERPRISE",
  TERRITORIAL_AGENT: "TERRITORIAL_AGENT",
  RETIRED_TERRITORIAL_AGENT: "RETIRED_TERRITORIAL_AGENT",
  MUNICIPALITY: "MUNICIPALITY",
  PARTICULAR: "PARTICULAR",
  BUSINESS_LEADER: "BUSINESS_LEADER",
  THIS_FAMILY: "THIS_FAMILY",
  C2SP: "C2SP",
  C2S_EXIT_CONTRACT: "C2S_EXIT_CONTRACT",
  ASSOCIATION_MEMBER: "ASSOCIATION_MEMBER",
  RENAULT_EMPLOYEE: "RENAULT_EMPLOYEE",
  MIDDLE_MANAGER: "MIDDLE_MANAGER",
  SENIOR_MANAGER: "SENIOR_MANAGER",
  CEO: "CEO",
};

/**
 * Acoris parcours profile subset. Values must exist in {@link PROFILE_LIST}
 * so they stay aligned with Health administration eligibility rules.
 */
export const ACORIS_PROFILES = {
  PARTICULAR: PROFILE_LIST.PARTICULAR,
  TNS: PROFILE_LIST.TNS,
  TERRITORIAL_AGENT: PROFILE_LIST.TERRITORIAL_AGENT,
  BUSINESS_LEADER: PROFILE_LIST.BUSINESS_LEADER,
  CROSS_BORDER_WORKER: PROFILE_LIST.CROSS_BORDER_WORKER,
};

export const SUPPORTING_DOCUMENTS = {
  ID: "ID",
  KBIS: "KBIS",
  PAY_SLIP: "PAY_SLIP",
  TAX_NOTICE: "TAX_NOTICE",
  RIB_SERVICE: "RIB_SERVICE",
  ELIGIBILITY: "ELIGIBILITY",
  PENSION_FUND: "PENSION_FUND",
  PAYMENT_ACCOUNT: "PAYMENT_ACCOUNT",
  COMMUNITY_ATTACHMENT: "COMMUNITY_ATTACHMENT",
  CHILD_DEPENDENT_PROOF: "CHILD_DEPENDENT_PROOF",
  SOCIAL_SECURITY_CERTIFICATE: "SOCIAL_SECURITY_CERTIFICATE",
  MARITAL_CERTIFICATE: "MARITAL_CERTIFICATE",
  HEALTH_INSURANCE_RIGHTS_CERTIFICATE: "HEALTH_INSURANCE_RIGHTS_CERTIFICATE",
  CONTRIBUTION_PAYMENT_AGREEMENT: "CONTRIBUTION_PAYMENT_AGREEMENT",
  PROFESSIONAL_PAYMENT_ACCOUNT: "PROFESSIONAL_PAYMENT_ACCOUNT",
  STUDENT_ID_OR_ENROLLMENT_CERTIFICATE: "STUDENT_ID_OR_ENROLLMENT_CERTIFICATE",
};

export const EVENT_TYPES = {
  NOTIFICATION: "NOTIFICATION",
  REMINDER: "REMINDER",
};

export const PAYMENT_STATUS = {
  PENDING: "PENDING",
  PAID: "PAID",
  FAILED: "FAILED",
};

export const PRODUCT_CATEGORIES = {
  LMF: {
    PHARMACY: "PHARMACY",
    HOSPITALIZATION: "HOSPITALIZATION",
    HONORARIES: "HONORARIES",
    A: "A",
    B: "B",
    C: "C",
  },
  AMELLIS: {
    SURCO: "SurComplémentaire",
    OPTICAL_DENTAL: "Renfort Optique/Dentaire ",
    HOSPITAL_GUARANTEE: "Garantie Hospitalière",
  },
  MCCI: {
    ZENITH: "ZENITH",
    SENIOR: "SENIOR",
    SIMPLY_PRO: "SIMPLY_PRO",
  },
};

export const SUR_COMPLEMENT_WEIGHT = 2;

export const IBAN_LENGTHS = {
  AT: 20,
  BE: 16,
  BG: 22,
  CH: 21,
  CY: 28,
  CZ: 24,
  DE: 22,
  DK: 18,
  EE: 20,
  ES: 24,
  FI: 18,
  FR: 27,
  GB: 22,
  GI: 23,
  GR: 27,
  HR: 21,
  HU: 28,
  IE: 22,
  IS: 26,
  IT: 27,
  LT: 20,
  LU: 20,
  LV: 21,
  MT: 31,
  NL: 18,
  NO: 15,
  PL: 28,
  PT: 25,
  RO: 24,
  SE: 24,
  SI: 19,
  SK: 24,
  SM: 27,
  TR: 26,
  AD: 24,
  AE: 23,
  AO: 25,
  AZ: 28,
  BH: 22,
  BR: 29,
  CR: 22,
  DO: 28,
  FO: 18,
  GE: 22,
  GL: 18,
  GT: 28,
  IL: 23,
  JO: 30,
  KW: 30,
  KZ: 20,
  LB: 28,
  LC: 32,
  LI: 21,
  MC: 27,
  MD: 24,
  ME: 22,
  MK: 19,
  MR: 27,
  MU: 30,
  PK: 24,
  PS: 29,
  QA: 29,
  RS: 22,
  SA: 24,
  SC: 31,
  TN: 24,
  UA: 29,
  VA: 22,
  VG: 24,
  MA: 24,
};

export const SELLIGENT_STEPS = {
  PROSPECTION: "PROSPECTION",
  PROPOSITION: "PROPOSITION",
  SIGNATURE: "SIGNATURE",
};

export const GUIMINI_STEPS = {
  QUALIFICATION: "A qualifier",
  CLIENT: "Client",
};

export const TASK_STATUSES = {
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
};

/** Workflow vs UI-created tasks (matches API `type` on Task) */
export const TASK_TYPES = {
  AUTOMATIC: "AUTOMATIC",
  MANUAL: "MANUAL",
};

/** Task category (matches API `subtype` on Task) */
export const TASK_SUBTYPES = {
  GENERIC: "GENERIC",
  CALL: "CALL",
  EMAIL: "EMAIL",
  REMINDER: "REMINDER",
};

export const TASK_PRIORITIES = {
  NONE: "NONE",
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  HIGH: "HIGH",
};

export const NOTIFICATION_TYPES = {
  TASK_REMINDER: "TASK_REMINDER",
  MISSED_CALL: "MISSED_CALL",
  NEW_LEAD: "NEW_LEAD",
  SYSTEM: "SYSTEM",
};

export const NOTIFICATION_IMPORTANCE = {
  NORMAL: "NORMAL",
  HIGH: "HIGH",
};

export const MILTIS_PRODUCT_CODES = {
  AURA: "AURA_MIL",
  AURA_TER: "AURA_TERRI",
  LUMINEIS: "LUMINEIS",
  OBSEQUE: "OBSEQUE",
};

export const MILTIS_B2B_OBSEQUES_PROCESS_ID = "cmu2oj9bz0096b0fdftenexyg";
export const MILTIS_OBSEQUES_ADVISOR_PROCESS_IDS = [
  MILTIS_B2B_OBSEQUES_PROCESS_ID,
  "cmu3xklgv0092xwfdfelzemp1",
];
export const PPE_PERSON_STATUS = {
  PENDING: "pending",
  VERIFIED: "verified",
  ALERT: "alert",
  BLOCKED: "blocked",
};

export const PPE_ALERT_STATUS = {
  PENDING: "PENDING",
  RAISED: "RAISED",
  CONFIRMED: "CONFIRMED",
};

export const PPE_ALERT_TYPE = {
  GELS_SANCTIONS: "gels_sanctions",
  PPE_NATIONALES: "ppe_nationales",
  PPE_INTERNATIONALES: "ppe_internationales",
};

export const MOBILE_MEANS = {
  NO_TRANSPORT: "NO_TRANSPORT",
  ELECTRIC_CYCLE: "ELECTRIC_CYCLE",
  HYBRID_CAR: "HYBRID_CAR",
  THERMICAL_CAR: "THERMICAL_CAR",
  ELECTRIC_CAR: "ELECTRIC_CAR",
};
export const PROPERTY_OWNERSHIP = {
  RENTED: "RENTED",
  OWNED: "OWNED",
};

export const DOCUMENT_FILENAME_DYNAMIC_FIELDS = [
  "contacts.insurrer.firstname",
  "contacts.insurrer.lastname",
  "contacts.insurrer.fullname",
  "contacts.insurrer.birthDate",
  "contacts.insurrer.socialSecurityNumber",
  "contacts.insurrer.email",
  "contacts.insurrer.phone",
  "contacts.insurrer.address.zipCode",
  "contacts.insurrer.address.city",
  "contacts.spouse.fullname",
  "insurancePlan.id",
  "insurancePlan.name",
  "insurancePlan.alias",
  "insurancePlan.category",
  "insurancePlan.risk",
  "insurancePlan.cost",
  "project.id",
  "project.number",
  "project.effectiveDate",
  "quoteNumber",
  "organization.name",
  "broker.socialReason",
  "broker.code",
  "broker.orias",
  "author.fullname",
  "author.email",
];

export const DYNAMIC_DOCUMENTS = {
  LMF: {
    QUOTE: {
      DEFAULT: "DEFAULT",
      MDC_SANTE: "MDC_SANTE",
      LMF_TERRI_2026_V1: "LMF_TERRI_2026_V1",
      ASSO_2026_V1: "ASSO_2026_V1",
      LMF_SANTE_TNS: "LMF_SANTE_TNS",
      IDF_SANTE: "IDF_SANTE",
      IDF_SANTE_TNS: "IDF_SANTE_TNS",
      SURCOMPLEMENT: "SURCOMPLEMENT",
      SURCOMPLEMENT_TNS: "SURCOMPLEMENT_TNS",
    },
    DUTY_OF_ADVICE_QUOTE: { DEFAULT: "DEFAULT" },
    DUTY_OF_ADVICE: { DEFAULT: "DEFAULT" },
    SEPA_DIRECT_DEBIT_MANDATE: { DEFAULT: "DEFAULT" },
    MEMBERSHIP_FORM: {
      BAI_LMF_SANTE_OK: "BAI_LMF_SANTE_OK",
      BIA_CONFORT_TNS: "BIA_CONFORT_TNS",
      BIA_IDF_MUTUELLE_SANTE_TNS: "BIA_IDF_MUTUELLE_SANTE_TNS",
      BAI_LMF_TERRI_OK: "BAI_LMF_TERRI_OK",
      BIA_MDC_SPE: "BIA_MDC_SPE",
      BIA_ASSOCIATION: "BIA_ASSOCIATION",
      BIA_CONFORT_OK: "BIA_CONFORT_OK",
      BIA_IDF_MUTUELLE_SANTE_OK: "BIA_IDF_MUTUELLE_SANTE_OK",
      BIA_LMF_SANTE_TNS_OK: "BIA_LMF_SANTE_TNS_OK",
    },
    APPENDIX_MEMBERSHIP_FORM: {
      DEFAULT: "DEFAULT",
      AFFILIATION: "AFFILIATION",
      AFFILIATION_RENFORTS: "AFFILIATION_RENFORTS",
      INDIVIDUELLE: "INDIVIDUELLE",
      INDIVIDUELLE_RENFORTS: "INDIVIDUELLE_RENFORTS",
    },
    SUPPLEMENTARY_DOCUMENTS: {
      BAI_LMF_SANTE_OK: "BAI_LMF_SANTE_OK",
      BIA_CONFORT_TNS: "BIA_CONFORT_TNS",
      BIA_IDF_MUTUELLE_SANTE_TNS: "BIA_IDF_MUTUELLE_SANTE_TNS",
      BAI_LMF_TERRI_OK: "BAI_LMF_TERRI_OK",
      BIA_MDC_SPE: "BIA_MDC_SPE",
      BIA_ASSOCIATION: "BIA_ASSOCIATION",
      BIA_CONFORT_OK: "BIA_CONFORT_OK",
      BIA_IDF_MUTUELLE_SANTE_OK: "BIA_IDF_MUTUELLE_SANTE_OK",
      BIA_LMF_SANTE_TNS_OK: "BIA_LMF_SANTE_TNS_OK",
    },
    DYNAMIC_INFO_NOTICE: { DEFAULT: "DEFAULT" },
    RGPD: { DEFAULT: "DEFAULT" },
    TERMINATION_LETTER: { DEFAULT: "DEFAULT" },
    TERMINATION_MANDATE: { DEFAULT: "DEFAULT" },
  },
  MCCI: {
    QUOTE: { DEFAULT: "DEFAULT", VERSION_2025: "VERSION_2025" },
    DUTY_OF_ADVICE: { DEFAULT: "DEFAULT" },
    MEMBERSHIP_FORM: { DEFAULT: "DEFAULT" },
    SEPA_DIRECT_DEBIT_MANDATE: { DEFAULT: "DEFAULT" },
    TERMINATION_LETTER: { DEFAULT: "DEFAULT" },
    TERMINATION_MANDATE: { DEFAULT: "DEFAULT" },
  },
  RADIANCE: {
    DUTY_OF_ADVICE_QUOTE: {
      DEFAULT: "DEFAULT",
      COSA_TER: "COSA_TER",
      AURA_TERR: "AURA_TERR",
      MUTUELLE_AURA: "MUTUELLE_AURA",
    },
    DUTY_OF_ADVICE: {
      DEFAULT: "DEFAULT",
      COSA_TER: "COSA_TER",
      AURA_TERR: "AURA_TERR",
      MUTUELLE_AURA: "MUTUELLE_AURA",
    },
    QUOTE: {
      COSA_TER: "COSA_TER",
      MUTUELLE_AURA: "MUTUELLE_AURA",
      AURA_TERR: "AURA_TERR",
    },
    MEMBERSHIP_FORM: {
      COSA_TER: "COSA_TER",
      MUTUELLE_AURA: "MUTUELLE_AURA",
      AURA_TERR: "AURA_TERR",
    },
    SEPA_DIRECT_DEBIT_MANDATE: {
      COSA_TER: "COSA_TER",
      MUTUELLE_AURA: "MUTUELLE_AURA",
    },
    TERMINATION_LETTER: {
      COSA_TER: "COSA_TER",
      MUTUELLE_AURA: "MUTUELLE_AURA",
    },
    TERMINATION_MANDATE: {
      COSA_TER: "COSA_TER",
      MUTUELLE_AURA: "MUTUELLE_AURA",
    },
  },
  ANSET: {
    QUOTE: {
      DEFAULT: "DEFAULT",
      DEVIS_PREMIUM_avec_franchise_XPF: "DEVIS_PREMIUM_avec_franchise_XPF",
      DEVIS_PREMIUM_sans_franchise_XPF: "DEVIS_PREMIUM_sans_franchise_XPF",
      DEVIS_SMART_avec_franchise_XPF: "DEVIS_SMART_avec_franchise_XPF",
      DEVIS_SMART_sans_franchise_XPF: "DEVIS_SMART_sans_franchise_XPF",
      DEVIS_PREMIUM_avec_franchise_EUR: "DEVIS_PREMIUM_avec_franchise_EUR",
      DEVIS_PREMIUM_sans_franchise_EUR: "DEVIS_PREMIUM_sans_franchise_EUR",
      DEVIS_SMART_avec_franchise_EUR: "DEVIS_SMART_avec_franchise_EUR",
      DEVIS_SMART_sans_franchise_EUR: "DEVIS_SMART_sans_franchise_EUR",
    },
    DUTY_OF_ADVICE: {
      DEFAULT: "DEFAULT",
      FORMALISATION_PREMIUM_avec_franchise_XPF:
        "FORMALISATION_PREMIUM_avec_franchise_XPF",
      FORMALISATION_PREMIUM_sans_franchise_XPF:
        "FORMALISATION_PREMIUM_sans_franchise_XPF",
      FORMALISATION_SMART_avec_franchise_XPF:
        "FORMALISATION_SMART_avec_franchise_XPF",
      FORMALISATION_SMART_sans_franchise_XPF:
        "FORMALISATION_SMART_sans_franchise_XPF",
      FORMALISATION_PREMIUM_avec_franchise_EUR:
        "FORMALISATION_PREMIUM_avec_franchise_EUR",
      FORMALISATION_PREMIUM_sans_franchise_EUR:
        "FORMALISATION_PREMIUM_sans_franchise_EUR",
      FORMALISATION_SMART_avec_franchise_EUR:
        "FORMALISATION_SMART_avec_franchise_EUR",
      FORMALISATION_SMART_sans_franchise_EUR:
        "FORMALISATION_SMART_sans_franchise_EUR",
    },
    PROPOSAL: { DEFAULT: "DEFAULT" },
    SPECIAL_CONDITIONS: {
      DEFAULT: "DEFAULT",
      CP_PREMIUM_avec_franchise_XPF: "CP_PREMIUM_avec_franchise_XPF",
      CP_PREMIUM_sans_franchise_XPF: "CP_PREMIUM_sans_franchise_XPF",
      CP_SMART_avec_franchise_XPF: "CP_SMART_avec_franchise_XPF",
      CP_SMART_sans_franchise_XPF: "CP_SMART_sans_franchise_XPF",
      CP_PREMIUM_avec_franchise_EUR: "CP_PREMIUM_avec_franchise_EUR",
      CP_PREMIUM_sans_franchise_EUR: "CP_PREMIUM_sans_franchise_EUR",
      CP_SMART_avec_franchise_EUR: "CP_SMART_avec_franchise_EUR",
      CP_SMART_sans_franchise_EUR: "CP_SMART_sans_franchise_EUR",
    },
    DIRECT_DEBIT_AUTHORIZATION: { DEFAULT: "DEFAULT" },
    SEPA_DIRECT_DEBIT_MANDATE: { DEFAULT: "DEFAULT" },
    COLLECTION_SCHEDULE: { DEFAULT: "DEFAULT" },
  },
  SOLYON: {
    QUOTE: { DEFAULT: "DEFAULT", PREMEO: "PREMEO" },
    MEMBERSHIP_FORM: { DEFAULT: "DEFAULT", PREMEO: "PREMEO" },
    TERMINATION_LETTER: { DEFAULT: "DEFAULT" },
    TERMINATION_MANDATE: { DEFAULT: "DEFAULT" },
  },
  AMELLIS: {
    QUOTE: { DEFAULT: "DEFAULT", VERSION_2026: "VERSION_2026" },
    MEMBERSHIP_FORM: {
      DEFAULT: "DEFAULT",
      COLLECTIVE: "COLLECTIVE",
      COLLECTIVE_WITHOUT_SIGNATURE: "COLLECTIVE_WITHOUT_SIGNATURE",
      BA_SAL_SIG_UNI: "BA_SAL_SIG_UNI",
      BA_SAL_SIG_MOD: "BA_SAL_SIG_MOD",
      BA_SAL_VAL_UNI: "BA_SAL_VAL_UNI",
      BA_SAL_VAL_MOD: "BA_SAL_VAL_MOD",
      BA_AGT_SIG_UNI: "BA_AGT_SIG_UNI",
      BA_AGT_SIG_MOD: "BA_AGT_SIG_MOD",
      BA_AGT_VAL_UNI: "BA_AGT_VAL_UNI",
      BA_AGT_VAL_MOD: "BA_AGT_VAL_MOD",
    },
    CONSENT_FORM: { DEFAULT: "DEFAULT" },
    DUTY_OF_ADVICE: { DEFAULT: "DEFAULT" },
    SEPA_DIRECT_DEBIT_MANDATE: { DEFAULT: "DEFAULT" },
    WITHDRAWAL_FORM: { DEFAULT: "DEFAULT" },
    TERMINATION_LETTER: { DEFAULT: "DEFAULT", VERSION_2026: "VERSION_2026" },
    TERMINATION_MANDATE: { DEFAULT: "DEFAULT", VERSION_2026: "VERSION_2026" },
  },
  MUTUAL_MOBILITY: {
    QUOTE: { DEFAULT: "DEFAULT" },
    DUTY_OF_ADVICE_QUOTE: { DEFAULT: "DEFAULT" },
    DUTY_OF_ADVICE: { DEFAULT: "DEFAULT" },
    MEMBERSHIP_FORM: {
      DEFAULT: "DEFAULT",
      BIA_MOBILITY_HEALTH: "BIA_MOBILITY_HEALTH",
      BIA_BASE_MANDAT: "BIA_BASE_MANDAT",
      BIA_CONFORT_MANDAT: "BIA_CONFORT_MANDAT",
      BIA_SERENITE_MANDAT: "BIA_SERENITE_MANDAT",
      BIA_LIBERTE_MANDAT: "BIA_LIBERTE_MANDAT",
      BIA_TNS_MANDAT: "BIA_TNS_MANDAT",
      BIA_VITALITE_MANDAT: "BIA_VITALITE_MANDAT",
    },
    SUPPLEMENTARY_DOCUMENTS: {
      DEFAULT: "DEFAULT",
      BIA_MOBILITY_HEALTH: "BIA_MOBILITY_HEALTH",
      BIA_BASE_MANDAT: "BIA_BASE_MANDAT",
      BIA_CONFORT_MANDAT: "BIA_CONFORT_MANDAT",
      BIA_SERENITE_MANDAT: "BIA_SERENITE_MANDAT",
      BIA_LIBERTE_MANDAT: "BIA_LIBERTE_MANDAT",
      BIA_TNS_MANDAT: "BIA_TNS_MANDAT",
      BIA_VITALITE_MANDAT: "BIA_VITALITE_MANDAT",
    },
    SEPA_DIRECT_DEBIT_MANDATE: { DEFAULT: "DEFAULT" },
    TERMINATION_MANDATE: { DEFAULT: "DEFAULT" },
  },
  MILTIS: {
    QUOTE: { DEFAULT: "DEFAULT", AURA_TERR: "AURA_TERR", LUMINEIS: "LUMINEIS" },
    DUTY_OF_ADVICE_QUOTE: { DEFAULT: "DEFAULT" },
    DUTY_OF_ADVICE: { DEFAULT: "DEFAULT" },
    MEMBERSHIP_FORM: {
      DEFAULT: "DEFAULT",
      AURA_TERR: "AURA_TERR",
      LUMINEIS: "LUMINEIS",
    },
    SEPA_DIRECT_DEBIT_MANDATE: { DEFAULT: "DEFAULT" },
    TERMINATION_MANDATE: { DEFAULT: "DEFAULT" },
  },
  SNCA: {
    DUTY_OF_ADVICE_QUOTE: { DEFAULT: "DEFAULT" },
    QUOTE: { DEFAULT: "DEFAULT" },
    DUTY_OF_ADVICE: { DEFAULT: "DEFAULT" },
    MEMBERSHIP_FORM: { DEFAULT: "DEFAULT" },
    SEPA_DIRECT_DEBIT_MANDATE: { DEFAULT: "DEFAULT" },
    TERMINATION_LETTER: { DEFAULT: "DEFAULT" },
    TERMINATION_MANDATE: { DEFAULT: "DEFAULT" },
  },
};

export const QUOTE_ATTACHMENT_ORDER = {
  QUOTE: 1,
  DUTY_OF_ADVICE_QUOTE: 2,
  DIRECT_DEBIT_AUTHORIZATION: 3,
  COLLECTION_SCHEDULE: 3,
  PROPOSAL: 4,
  SPECIAL_CONDITIONS: 5,
  PARTICULAR_PROVISIONS: 5,
  BROCHURE: 6,
  COVERAGE_GRID: 6,
  REIMBURSEMENT_EXAMPLES: 6,
  IPID: 7,
  INFO_NOTICE: 8,
  STATUSES: 9,
  REGULATION: 9,
  RGPD: 10,
  DEFAULT: 20,
};

export const EMPLOYEE_CATEGORIES = {
  ALL_STAFF: "ensemble_personnel",
  CADRE: "cadre",
  NON_CADRE: "non_cadre",
};

export const CONTRIBUTION_STRUCTURES = {
  EMPLOYEE_SPOUSE_CHILD: "salarie_conjoint_enfant",
  SINGLE_FAMILY: "isole_famille",
  SINGLE_DUO_FAMILY: "isole_duo_famille",
  FLAT_FAMILY_RATE: "taux_unique_famille",
};

export const MEMBER_TYPES = {
  EMPLOYEE: "salarie",
  SPOUSE: "conjoint",
  CHILD: "enfant",
  SINGLE: "isole",
  DUO: "duo",
  FAMILY: "famille",
};

export const CONTRIBUTION_STRUCTURE_MEMBERS = {
  [CONTRIBUTION_STRUCTURES.EMPLOYEE_SPOUSE_CHILD]: [
    MEMBER_TYPES.EMPLOYEE,
    MEMBER_TYPES.SPOUSE,
    MEMBER_TYPES.CHILD,
  ],
  [CONTRIBUTION_STRUCTURES.SINGLE_FAMILY]: [
    MEMBER_TYPES.SINGLE,
    MEMBER_TYPES.FAMILY,
  ],
  [CONTRIBUTION_STRUCTURES.SINGLE_DUO_FAMILY]: [
    MEMBER_TYPES.SINGLE,
    MEMBER_TYPES.DUO,
    MEMBER_TYPES.FAMILY,
  ],
  [CONTRIBUTION_STRUCTURES.FLAT_FAMILY_RATE]: [MEMBER_TYPES.FAMILY],
};

export const PRIMARY_MEMBER_TYPES = {
  [CONTRIBUTION_STRUCTURES.EMPLOYEE_SPOUSE_CHILD]: [MEMBER_TYPES.EMPLOYEE],
  [CONTRIBUTION_STRUCTURES.SINGLE_FAMILY]: [
    MEMBER_TYPES.SINGLE,
    MEMBER_TYPES.FAMILY,
  ],
  [CONTRIBUTION_STRUCTURES.SINGLE_DUO_FAMILY]: [
    MEMBER_TYPES.SINGLE,
    MEMBER_TYPES.DUO,
    MEMBER_TYPES.FAMILY,
  ],
  [CONTRIBUTION_STRUCTURES.FLAT_FAMILY_RATE]: [MEMBER_TYPES.FAMILY],
};

export const COLLECTIVE_OFFER_RANKS = {
  BASE: "base",
  OPTION_1: "option_1",
  OPTION_2: "option_2",
};

export const COLLECTIVE_OFFER_RANK_ORDER = [
  COLLECTIVE_OFFER_RANKS.BASE,
  COLLECTIVE_OFFER_RANKS.OPTION_1,
  COLLECTIVE_OFFER_RANKS.OPTION_2,
];

export const ESIGN_IFRAME = {
  TAG: "IFRAME",
  PROTOCOL: "https:",
  SANDBOX_ENV_VALUE: "true",
  LOAD_DELAY_MS: 3000,
  BLANK_SRC: "about:blank",
  PROVIDERS: [
    {
      HOSTS: ["yousign.app"],
      PARAMS: {},
      SANDBOX_PARAMS: { disable_domain_validation: "true" },
    },
    {
      HOSTS: ["apps.universign.com", "apps.alpha.universign.com"],
      PARAMS: { iframe: "true" },
      SANDBOX_PARAMS: {},
    },
  ],
};
